import React, { useEffect, useRef, useState } from 'react';
import { Dropdown, MenuProps, Select, Tooltip } from 'antd';
import moment from 'moment';
import { SuesModel } from '../models/SuesModel';
import { Sue, TreatmentType } from '../models/superbit-api-models';
// import ConfirmPopUp from '../tasks/_ConfirmPopup';
import { ClientPopup } from '../clients/_ClientPopup';
import { LeadDocumentPopup } from '../leads/_LeadDocumentPopup';
import "./_sues.css";
import InvolvedVehicle from './_InvolvedVehicleItem';
import PersonalSueDetails from './_PersonalSueDetails';
import GeneralCarDetails from './_GeneralCarDetails';
import GeneralOtherDetails from './_GeneralOtherDetails';
import AccidentDetailsAndPlace from './_AccidentDetailsAndPlace';
import VictimsAndWitnesses from './_VictimsAndWitnesses';
import AppraiserDetails from './_AppraiserDetails';
import VehicleAndDriverDetails from './_VehicleAndDriverDetails';
import _, { set } from 'lodash';
import AccidentDetailsAndPlaceOnCar from './_AccidentDetailsAndPlaceOnCar';
import TreatmentsSue from './_TreatmentsSue';
import ErrorFieldsAlert from '../components/_ErrorFieldsAlert';
import { setReloadSuesData } from '../app-context/suesSlice';
import { useDispatch, useSelector } from 'react-redux';
import SueAlertPopUp from './SueAlertPopUp';
import SueDocuments from './_SueDocuments';
import { RootState } from '../app-context/store';
import { setFileDocumentsUrl } from '../app-context/filesSlice';
import ClientDocumentPopup from '../clients/documents/_ClientDocumentPopup';

type Props = {
    customerId?: string;
    tabData: any;
    config: any;
    setLoading?: Function;
    updateEditData?: Function;
    updatePolicy?: Function;
    onFileDelete?: Function;
    onRelaodAfterSaveSue?: Function;
    updateMode?: Function;
    addSigningComment?: Function;
    isPopUp?: boolean;
    cancelAddClaimPoopup?: Function;
};

const SueDocumentFile = (props: any) => {
    const [document, setDocument] = useState<any>(props.document);
    const [fileName, setFileName] = useState<string>('');
    const [fileMenuOptions, setFileMenuOptions] = useState<MenuProps['items']>([]);

    const onFileDelete = () => {
        props.onFileDelete(props.document, props.index);
    }

    const onSelectDocument = () => {
        if (!props.document.isAttachment) {
            props.onSelectDocument(props.document);
        }
    }
    const emptyFunc = () => { }

    useEffect(() => {
        let isAdmin = false;
        const savedLoggedUser = localStorage.getItem('loggedUser');
        let loggedUser: any = {}
        if (savedLoggedUser) {
            loggedUser = JSON.parse(savedLoggedUser);
            isAdmin = loggedUser.role == 0;
        }
        const menuOptions: MenuProps['items'] = props.document.sueId ? [
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { props.onFileSelect ? props.onFileSelect(document.id) : emptyFunc() }}
                    >
                        הצגה
                    </li>,
                key: 'show',
            },
            {
                label:
                    <li className="pointer rtl"
                        onClick={() => { props.onFileDownload ? props.onFileDownload(document.id) : emptyFunc() }}
                    >
                        הורדה
                    </li>,
                key: 'download',
            }
        ] : [];
        if (isAdmin && props.document.sueId) {
            menuOptions.push({
                label:
                    <li className="pointer rtl"
                        onClick={() => { props.onFileDelete ? props.onFileDelete(document.id) : emptyFunc() }}
                    >
                        מחיקה
                    </li>,
                key: 'delete',
            })
        }
        setFileMenuOptions(menuOptions)

    }, [])

    useEffect(() => {
        let fileName: string = '';
        let filePathData: string[] = []
        if (document.path.indexOf("/") > 0) {
            filePathData = document.path.split("/");
        } else {
            filePathData = document.path.split("\\");
        }
        fileName = filePathData[filePathData.length - 1];
        setFileName(fileName)
    }, [props]);

    return <Dropdown menu={{ items: fileMenuOptions }} trigger={['contextMenu']}>
        <div className="sue-documents-section" key={props.index} onDoubleClick={() => onSelectDocument()}>
            <div className="sue-documents-item">
                <Tooltip title={fileName} color={'#027BFD'} placement="topRight">
                    {document.name}
                </Tooltip>
            </div>
            <div className="sue-documents-item">
                <div className='file-date-time'>
                    <span>{document.createdDate && moment(document.createdDate).format('DD-MM-YYYY')}</span>
                    <span style={{ color: 'gray', marginRight: 20 }}>{document.createdDate && moment(document.createdDate).format('HH:mm')}</span>
                </div>
            </div>
            <div className="sue-documents-item">
                {document.userName}
            </div>
            <div className="sue-documents-item">
                {document.size}
            </div>
            <div className="sue-documents-item">
                {document.comment}
            </div>
            <div className="sue-documents-item">
                <Dropdown menu={{ items: fileMenuOptions }}>
                    <div className="act-btn-icon icon menu-hamburger pointer"></div>
                </Dropdown>
            </div>
        </div>
    </Dropdown>
}

const SueItemUpdate = (props: Props) => {
    const suesModel = new SuesModel();
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const dispatch = useDispatch();
    const fileDocumentsUrl = useSelector((state: RootState) => state.files.fileDocumentsUrl)


    const [formErrors, setFormErrors] = useState<any>({
        sueType: false,
        policyNumber: false,
        sueHandler: false,
        openingDate: false,
        activityStatus: false,
        insuranceCompany: false,
        status: false,
        approvedAmountPayment: false,
        requestedAmountPayment: false
    })
    const [apiUrl, setApiUrl] = useState<string>('');
    const [selectedDocumentUrl, setSelectedDocumentUrl] = useState<string | null>(null);
    const [accidentDate, setAccidentDate] = useState<string>('')
    const [accidentTime, setAccidentTime] = useState<string>('00:00');

    const [filesForUpload, setFilesForUpload] = useState<any[]>([]);

    const [tab, setTab] = useState<string>('General');
    const [sueData, setSueData] = useState<any>({});

    const [sueDataOrig, setSueDataOrig] = useState<any>({});
    const [dataToUpdate, setDataToUpdate] = useState<any | null>();
    const [customer, setCustomer] = useState<any | null>(null);
    const [driver, setDriver] = useState<any | null>(null);
    const [garageDetails, setGarageDetails] = useState<any | null>(null);
    const [showNewPayment, setShowNewPayment] = useState<boolean>(false);

    const [customerPhone, setCustomerPhone] = useState<any | null>(null)
    const [customerAdditionalPhone, setCustomerAdditionalPhone] = useState<any | null>(null)
    const [customerEmail, setCustomerEmail] = useState<any | null>(null)
    const [address, setAddress] = useState<any>({});
    const [documentsList, setDocumentsList] = useState<any[]>([]);
    const [showFileUpload, setShowFileUpload] = useState<boolean>(false);
    const [uploadFileComment, setUploadFileComment] = useState<string>('');
    const [uploadFile, setUploadFile] = useState<any | null>(null);
    const [policyNumber, setPolicyNumber] = useState<string>('');
    const [policyTypeId, setPolicyTypeId] = useState<number>(1);

    const [sueTypes, setSueTypes] = useState<any[]>(props.config.sueTypes ? props.config.sueTypes : []);
    const [showLessTabs, setShowLessTabs] = useState<boolean>(false);
    const [statusId, setStatusId] = useState<string>('0');
    const [status, setStatus] = useState<string>('');
    const [gender, setGender] = useState<string>('');

    const [sueStatusLabel, setSueStatusLabel] = useState<string>('')
    const [sueActivityStatusLabel, setSueActivityStatusLabel] = useState<string>('')
    const [sueTypeLabel, setSueTypeLabel] = useState<string>('')
    const [sueGarageLabel, setSueGarageLabel] = useState<string>('')
    const [sueHandlerName, setSueHandlerName] = useState<string>('');
    const [sueHandlingProcess, setSueHandlingProcess] = useState<string>('');

    const [insuranceCompanyLabel, setInsuranceCompanyLabel] = useState<string>('');
    const [involvedVehicleInsuranceCompanyLabel, setInvolvedVehicleInsuranceCompanyLabel] = useState<string>('');

    const [sueInternalNumber, setSueInternalNumber] = useState<string>('')

    const [lastUpdate, setLastUpdate] = useState<Date | null>(null)
    const [openingDate, setOpeningDate] = useState<Date | null>(null);
    const [closingDate, setClosingDate] = useState<Date | null>(null);
    const [paymentDate, setPaymentDate] = useState<Date | null>(null);
    const [customerCheckMaturityDate, setCustomerCheckMaturityDate] = useState<Date | null>(null);

    const [driversType, setDriversType] = useState<string>('')
    const [vehicleOwnership, setVehicleOwnership] = useState<string>('');
    const [vehicleData, setVehicleData] = useState<any | null>(null);

    const [showConfirmationPopUp, setShowConfirmationPopup] = useState<boolean>(false);

    const [newSuePayment, setNewSuePayment] = useState<any>({
        requestedAmount: null,
        createdDate: null,
        title: '',
        supplier: '',
        approvedAmount: 0,
        claimedAmount: 0
    });

    const [suePaymentsList, setSuePaymentsList] = useState<any[]>([])
    const [newSueComment, setNewSueComment] = useState<any>({
        sueId: null,
        userId: null,
        comment: null
    })
    const [sueCommentsList, setSueCommentsList] = useState<any[]>([])
    const [sueDocumentList, setSueDocumentList] = useState<any[]>([])

    const [newTreatment, setNewTreatment] = useState<any>({
        treatmentType: 4,
        alertDate: null,
        topic: '',
        sueRelatedId: null
    });

    const [sueTreatmentsList, setSueTreatmentsList] = useState<any[]>([])
    const [creatorsList, setCreatorsList] = useState<any[]>([]);
    const [showErrorFieldsWarning, setShowErrorFieldsWarning] = useState<boolean>(false);
    const [garageChoosen, setGarageChoosen] = useState<boolean>(false);
    const [clientDocumentUrl, setClientDocumentUrl] = useState<string | null>(null)
    
    const typeOfCars = [{ label: 'פרטי', value: 0 },
    { label: 'מסחרי', value: 1 }]

const PrintSue = async (e: any) => {
    let sueId = sueData.id;
        let data = await new SuesModel().PrintSue(sueId);
        openPdf(data);
    }

    const openPdf = (url: string) => {
        window.open(url, "_blank");
    };
    const init = (sueItemData: any) => {
        console.log(props.config);
        console.log('SueDetails sueData', sueItemData);

        const creatorsList = localStorage.getItem('creatorsList');
        if (creatorsList) {
            setCreatorsList(JSON.parse(creatorsList))
        }

        let vechicleData = sueItemData.vehicle;
        if (!sueItemData.driver) {
            sueItemData.driver = {
                "sueId": sueItemData.id ? sueItemData.id : undefined,
                "sueCarAndDriverInfoId": undefined,
                "driverFullName": "",
                "driverIdentity": "",
                "driverBirthDate": undefined,
                "isDriverVehicleOwner": false,
                "isIsraeliLicense": false,
                "driverAddress": "",
                "driverPhoneNumber": "",
                "driverMobileNumber": "",
                "driverOwnerRelation": "",
                "driverLicensIssueDate": null,
                "driverLicenseNumber": "",
                "driverLicenseType": -1,
                "vehicleId": '00000000-0000-0000-0000-000000000000',
                "vehicleType": "",
                "vehicleYearOfProduction": 0,
                "vehicleLicensePlate": null,
                "vehicleGearboxType": 0,
                "licenseTypes": null,
                "yearsOfProduction": null,
                "gearboxTypes": null,
                "vehicleTypes": null,
                "extrasMultiSelect": null,
                "customerModel": null
            }
        }
        if (sueItemData.policy && sueItemData.policy.policyAdditionDetails) {
            if (sueItemData.policy.policyAdditionDetails.vehicle) {
                vechicleData = sueItemData.policy.policyAdditionDetails.vehicle;
                sueItemData.vehicle = vechicleData;
                sueItemData.vehicleId = vechicleData.id
                sueItemData.driver.vehicle = vechicleData;
                sueItemData.driver.vehicleId = vechicleData.id;
            }
            // if (vechicleData)
            //     sueItemData.driver.vehicleId = vechicleData.id;
        }
        if (sueItemData.driver && sueItemData.driver.vehicle) {
            vechicleData = sueItemData.driver.vehicle;
            sueItemData.vehicle = vechicleData;
            sueItemData.vehicleId = vechicleData.id
            if (vechicleData)
                sueItemData.driver.vehicleId = vechicleData.id;
        }
        if (sueItemData.rider && sueItemData.rider.vehicle) {
            vechicleData = sueItemData.rider.vehicle;
            sueItemData.vehicle = vechicleData;
            sueItemData.vehicleId = vechicleData.id
            sueItemData.driver.vehicleId = vechicleData.id;
        }

        if (vechicleData && vechicleData.rider == null
            && ((!vechicleData.modelCode || vechicleData.modelCode == '' || vechicleData.modelCode == '0')
                && (vechicleData.licenseNumber && vechicleData.licenseNumber.length == 6))
            && sueItemData.policy && sueItemData.policy.policyType && sueItemData.policy.policyType.policyTypeId == '9') {
            vechicleData["modelCode"] = '00000';
        }
        if (!vechicleData) {
            sueItemData.driver = undefined;
        } else {
            setVehicleData(vechicleData);
        }

        setOpeningDate(sueItemData.openingDate ? prepareDateValue(sueItemData.openingDate) : null);
        setClosingDate(sueItemData.closingDate ? prepareDateValue(sueItemData.closingDate) : null);
        setPaymentDate(sueItemData.paymentDate ? prepareDateValue(sueItemData.paymentDate) : null);
        setCustomerCheckMaturityDate(sueItemData.customerCheckMaturityDate ? prepareDateValue(sueItemData.customerCheckMaturityDate) : null);

        setSueDataOrig(_.cloneDeep(sueItemData));

        setSueData(sueItemData);
        setSuePaymentsList(sueItemData.payments ? sueItemData.payments : []);
        setSueCommentsList(sueItemData.sueComments ? sueItemData.sueComments : []);
        setSueDocumentList(sueItemData.documents ? sueItemData.documents : [])
        setSueTreatmentsList(sueItemData.treatments ? sueItemData.treatments : [])

        const sueType = props.config.sueTypes.find((a: any) => a.value == sueItemData.sueTypeId);
        if (sueType) {
            setSueTypeLabel(sueType.label)
        }
        const sueActivityStatus = props.config.sueActivityStatuses.find((a: any) => a.value == sueItemData.sueActivityStatusId);
        if (sueActivityStatus) {
            setSueActivityStatusLabel(sueActivityStatus.label);
        } else {
            sueItemData.sueActivityStatusId = "c0923f95-5dc7-4bb3-91f2-f40f0bc9ad2a"
            let defaultActivityStatus = props.config.sueActivityStatuses.find((a: any) => a.value == "c0923f95-5dc7-4bb3-91f2-f40f0bc9ad2a");
            if (defaultActivityStatus) {
                setSueActivityStatusLabel(defaultActivityStatus.label);
            }
        }
        const sueStatus = props.config.sueStatuses.find((a: any) => a.value == sueItemData.sueStatusId);
        if (sueStatus) {
            setSueStatusLabel(sueStatus.label);
        } else {
            sueItemData.sueStatusId = "ae5fe6f6-c617-42dc-a449-5c2a6b5ef899"
            let defaultStatus = props.config.sueStatuses.find((a: any) => a.value == "ae5fe6f6-c617-42dc-a449-5c2a6b5ef899");
            if (defaultStatus) {
                setSueStatusLabel(defaultStatus.label);
            }
        }

        if (sueItemData.handler) {
            setSueHandlerName(sueItemData.handler.fullName);
        }

        if (sueItemData.handlingType != null && sueItemData.handlingType >= 0 && sueItemData.handlingType.toString().length > 0) {
            console.log('init-sueItemData.handlingType', sueItemData.handlingType)
            let handlingTypes = [{ label: 'מוסך הסדר', value: '0' }, { label: 'ללא הסדר', value: '1' }, { label: 'הסדר צד ג\'', value: '2' }]
            let handlingType = handlingTypes.find((ht) => ht.value == sueItemData.handlingType.toString());
            console.log('init-sueItemDatahandlingType', handlingType)
            if (handlingType) {
                setSueHandlingProcess(handlingType.label)
            }
        }

        if (sueItemData.sueAccidentAndDamageInfo) {
            setAccidentDate(moment(sueItemData.sueAccidentAndDamageInfo.accidentDateTime).format('YYYY-MM-DD'));
            setAccidentTime(moment(sueItemData.sueAccidentAndDamageInfo.accidentDateTime).format('HH:mm'))
        } else {
            setAccidentTime('00:00');
        }

        if (sueItemData.driver) {
            const d: any = { ...sueItemData.driver };
            if (d.driverBirthDate == '0001-01-01T00:00:00') {
                d.driverBirthDate = null;
            }
            setDriver(d);
        } else {
            // this code never happens
            sueItemData.driver = {
                driverAddress: '',
                isDriverVehicleOwner: false,
                driverOwnerRelation: '',
                isIsraeliLicense: true,
                vehicleAdditions: '',
                vehicle: {
                    gearsType: 0
                }
            }
            setDriver(sueItemData.driver)
        }
        if (sueItemData.garageDetails) {
            setGarageDetails(sueItemData.garageDetails);
            if (sueItemData.garageDetails.garageName && sueItemData.garageDetails.garageName != '') {
                setGarageChoosen(true);
            }
        } else {
            sueItemData.garageDetails = {
                assessorName: '',
                assessorPhoneNumber: '',
                assessorMobilePhoneNumber: '',
                assessorFaxNumber: '',
                assessorAddress: '',
                assessorEmail: '',
                garageName: '',
                garagePhone: '',
                garageFaxNumber: '',
                garageAddress: '',
                garageEmail: '',
                garageIdentity: '',
                garageContactPerson: ''
            }
            setGarageDetails(sueItemData.sueGarageDetails)
            setGarageChoosen(false);
        }
    }

    const prepareDateValue = (dateStr: string) => {
        if (dateStr === '0001-01-01T00:00:00' || !moment(dateStr).isValid()) {
            return null;
        } else {
            return moment(dateStr).toDate();
        }
    }

    const getCreatorNameById = (id: string) => {
        if (creatorsList.length == 0) {
            return;
        }
        const selectedCreator = creatorsList.find((c: any) => c.id === id);
        if (selectedCreator) {
            return selectedCreator.fullName;
        } else {
            return '';
        }
    }

    const onSaveSue = async (data: any) => {
        console.log('onSaveSue', data);
        data.driverId = undefined;
        data.sueType = undefined;
        if (data.involvedVehiclesList) {
            // data.involvedVehiclesList.forEach((iv: any)=>{
            //     iv.id = undefined;
            // })
        }
        if (data.sueAccidentAndDamageInfo) {
            data.sueAccidentAndDamageInfo.sueAccidentAndDamageInfoId = undefined
        }
        if (!data.customerCheckMaturityDate) {
            data.customerCheckMaturityDate = null;
        }
        return await suesModel.sueUpdate(data);
    }

    const selectTab = (tabName: string) => {
        if ((sueData.id == null || sueData.id == '' || sueData.id == undefined) && tabName == 'OngoingCare') {
            return;
        }
        setTab(tabName);
    }

    const onSueStatusChange = async (e: any) => {
        const statusName = e.target.value;
        setSueStatusLabel(statusName);
        const selected = props.config.sueStatuses.find((a: any) => a.label == statusName);
        if (selected) {
            const sueCurrentData = sueData;
            sueCurrentData.sueStatusId = selected.value;
            if (selected.value == "0352e030-455b-46e9-9d4e-c9e73707f921") {
                console.log('onSueStatusChange-selected.value', selected.value)
                sueCurrentData.closingDate = moment().toDate();
                setClosingDate(moment().toDate());
            } else {
                sueCurrentData.closingDate = null;
                setClosingDate(null);
            }
            setSueData(sueCurrentData);
        } else {

        }
    }

    const onClearSueStatus = () => {
        setSueStatusLabel('');
        const sueCurrentData = sueData;
        sueCurrentData.activityStatus = 0;
        setSueData(sueCurrentData);
    }

    const onSueActivityStatusChange = async (e: any) => {
        const statusName = e.target.value;
        setSueActivityStatusLabel(statusName);
        const selected = props.config.sueActivityStatuses.find((a: any) => a.label == statusName);
        if (selected) {
            const sueCurrentData = sueData;
            sueCurrentData.sueActivityStatusId = selected.value;
            if (selected.value == "0352e030-455b-46e9-9d4e-c9e73707f921") {
                sueCurrentData.closingDate = moment().toDate();
                setClosingDate(moment().toDate());
            }
            setSueData(sueCurrentData);
            console.log('onSueStatusChange', selected, sueCurrentData)
        } else {

        }
    }

    const onClearSueActivityStatus = () => {
        setSueActivityStatusLabel('');
        const sueCurrentData = sueData;
        sueCurrentData.activityStatus = -1;
        setSueData(sueCurrentData);
    }

    const onInsuranceCompanyChange = async (e: any) => {
        const companyName = e.target.value;
        setInsuranceCompanyLabel(companyName);
        const selected = props.config.insuranceCompanies.find((a: any) => a.label == companyName);
        if (selected) {
            const sueCurrentData = sueData;
            sueCurrentData.insuranceCompany = selected;
            sueCurrentData.insuranceCompanyId = selected.value;
            setSueData(sueCurrentData);
            console.log('onInsuranceCompanyChange', selected, sueCurrentData)
        } else {

        }
    }

    const onClearInsuranceCompany = () => {
        setInsuranceCompanyLabel('');
        const sueCurrentData = sueData;
        sueCurrentData.insuranceCompany = undefined;
        sueCurrentData.insuranceCompanyId = undefined;
        setSueData(sueCurrentData);
    }

    const onGarageChange = async (e: any) => {
        const garageName = e.target.value;
        setSueGarageLabel(garageName);
        const garages: any[] = [...props.config.garages];
        const selectedGarageObject = garages.find((g: any) => g.shem_mosah == garageName);
        console.log(selectedGarageObject);
        if (selectedGarageObject) {
            console.log('selectedGarage', selectedGarageObject);
            const sueCurrentData = sueData;
            const sueGarageDetails: any = garageDetails;
            sueGarageDetails.garageName = selectedGarageObject.shem_mosah
            sueGarageDetails.garagePhone = selectedGarageObject.telephone
            sueGarageDetails.garageFaxNumber = selectedGarageObject.telephone
            sueGarageDetails.garageFaxNumber = selectedGarageObject.telephone
            sueGarageDetails.garageAddress = `${selectedGarageObject.yishuv}, ${selectedGarageObject.ktovet}`
            sueGarageDetails.garageEmail = selectedGarageObject.telephone
            sueGarageDetails.garageIdentity = selectedGarageObject.rasham_havarot
            sueGarageDetails.garageContactPerson = selectedGarageObject.menahel_miktzoa

            sueGarageDetails.garageDetails = false

            sueCurrentData.garageDetails = sueGarageDetails;
            setGarageDetails(sueGarageDetails);
            setSueData(sueCurrentData);
            setLastUpdate(moment().toDate());
            setGarageChoosen(true);
        }
    }

    const onClearGarage = () => {
        setSueGarageLabel('');
        setGarageDetails({
            assessorName: '',
            assessorPhoneNumber: '',
            assessorMobilePhoneNumber: '',
            assessorFaxNumber: '',
            assessorAddress: '',
            assessorEmail: '',
            garageName: '',
            garagePhone: '',
            garageFaxNumber: '',
            garageAddress: '',
            garageEmail: '',
            garageIdentity: '',
            garageContactPerson: ''
        });
        setGarageChoosen(false);
    }

    const onSueTypeChange = async (e: any) => {
        const statusName = e.target.value;
        setSueTypeLabel(statusName);
        const selected = props.config.sueTypes.find((a: any) => a.label == statusName);
        if (selected) {
            const sueCurrentData = sueData;
            sueCurrentData.sueTypeId = selected.value;
            setSueData(sueCurrentData);
        } else {

        }
    }

    const onClearSueType = () => {
        setSueTypeLabel('');
        const sueCurrentData = sueData;
        sueCurrentData.sueTypeId = '';
        setSueData(sueCurrentData);
    }

    const onSueHandlerChange = async (e: any) => {
        const statusName = e.target.value;
        setSueHandlerName(statusName);
        const selected = props.config.handlers.find((a: any) => a.label == statusName);
        if (selected) {
            const sueCurrentData = sueData;
            sueCurrentData.handlerId = selected.value;
            setSueData(sueCurrentData);
            console.log('onSueHandlerChange', selected, sueCurrentData)
        } else {

        }
    }

    const onHandlingTypeCareChange = async (e: any) => {
        const handlingType = e.target.value;
        setSueHandlingProcess(handlingType);
        const selected = [{ label: 'מוסך הסדר', value: '0' }, { label: 'ללא הסדר', value: '1' }, { label: 'הסדר צד ג\'', value: '2' }].find((a: any) => a.label == handlingType);
        if (selected) {
            const sueCurrentData = { ...sueData };
            sueCurrentData.handlingType = selected.value;
            setSueData(sueCurrentData);
            console.log('onHandlingTypeCareChange', selected, sueCurrentData)
        }
        setLastUpdate(moment().toDate());
    }
    const onClearSueHandler = () => {
        setSueHandlerName('');
        const sueCurrentData = sueData;
        sueCurrentData.handlerId = undefined;
        setSueData(sueCurrentData);
    }

    const onInternalNumberChange = async (e: any) => {
        const newInternalNumber: string = (e.target.value).toString().replace(/\D/g, "");
        setSueInternalNumber(newInternalNumber);
        const sueCurrentData = sueData;
        sueCurrentData.internalNumber = parseInt(newInternalNumber);
        await setSueData(sueCurrentData);
    }

    const onParameterChange = async (e: any, paramName: string, onlyNumbers: boolean = false) => {
        console.log('onParameterChange', e.target.value)
        const newValue: string = e.target.value;
        console.log('onParameterChange-newValue', newValue)
        const sueCurrentData = sueData;
        sueCurrentData[paramName] = newValue;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onParameterPaymentChange = (e: any, paramName: string) => {
        const newValue = e.target.value;
        console.log('onParameterPaymentChange-newValue', newValue);
        console.log('onParameterPaymentChange-paramName', paramName)
        const sueCurrentData = sueData;
        sueCurrentData[paramName] = newValue;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onSueSummaryAmountChange = async (e: any, paramName: string, onlyNumbers: boolean = false) => {
        const newValue: string = e.target.value;
        console.log('onSueSummaryAmountChange-newValue', newValue)
        const sueCurrentData = sueData;
        let damageAppraiser = sueCurrentData.damageAppraiser ? sueCurrentData.damageAppraiser : 0;
        let appraiserAmount = sueCurrentData.appraiserAmount ? sueCurrentData.appraiserAmount : 0;
        let impairment = sueCurrentData.impairment ? sueCurrentData.impairment : 0;
        let deductible = sueCurrentData.deductible ? sueCurrentData.deductible : 0;
        let establishmentValue = sueCurrentData.establishmentValue ? sueCurrentData.establishmentValue : 0;
        let sum = 0;
        if (paramName === 'damageAppraiser') {
            sueCurrentData[paramName] = Number(newValue);
            sum = Number(newValue) + appraiserAmount + impairment - (deductible + establishmentValue);
        } else if (paramName === 'appraiserAmount') {
            sueCurrentData[paramName] = Number(newValue);
            sum = damageAppraiser + Number(newValue) + impairment - (deductible + establishmentValue);
        } else if (paramName === 'impairment') {
            sueCurrentData[paramName] = Number(newValue);
            sum = damageAppraiser + appraiserAmount + Number(newValue) - (deductible + establishmentValue);
        } else if (paramName === 'deductible') {
            sueCurrentData[paramName] = Number(newValue);
            sum = damageAppraiser + appraiserAmount + impairment - (Number(newValue) + establishmentValue);
        } else if (paramName === 'establishmentValue') {
            sueCurrentData[paramName] = Number(newValue);
            sum = damageAppraiser + appraiserAmount + impairment - (deductible + Number(newValue));
        }
        sueCurrentData.requestedAmount = sum;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }





    const onParticipantWitnessChange = async (e: any, participantWitness: string, paramName: string, onlyNumbers: boolean = false) => {
        const newValue: string = e.target.value;
        const sueCurrentData = sueData;
        if (!sueCurrentData[participantWitness]) {
            sueCurrentData[participantWitness] = {
                name: ''
            }
        }
        sueCurrentData[participantWitness][paramName] = onlyNumbers ? newValue.replace(/\D/g, "") : newValue;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onPolicyNumberChange = (e: any) => {
        const newValue: string = e.target.value;
        const sueCurrentData = sueData;
        if (sueCurrentData.policy) {
            sueCurrentData.policy.policyNumber = newValue;
        }
        if (sueCurrentData.rider) {
            sueCurrentData.rider.subscriberNumber = newValue;
        }
        // sueData.rider.subscriberNumber
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onIsDriverVehicleOwnerChange = (e: any) => {
        console.log('onIsDriverVehicleOwnerChange', e.target.checked);
        console.log('sueData.customer.driverLicenseType', sueData.customer.driverLicenseType)
        const sueCurrentData = sueData;
        let newDriverData = { ...sueCurrentData.driver };
        newDriverData.isDriverVehicleOwner = e.target.checked;

        if (newDriverData.isDriverVehicleOwner) {
            newDriverData.driverFullName = sueData.customer.fullName;
            newDriverData.driverIdentity = sueData.customer.identifier;
            newDriverData.driverBirthDate = sueData.customer.dateOfBirth;
            newDriverData.driverAddress = sueData.customer.customerAddresses[0] ? `${sueData.customer.customerAddresses[0].city} ${sueData.customer.customerAddresses[0].street} ${sueData.customer.customerAddresses[0].houseNumber} ${sueData.customer.customerAddresses[0].postalCode}` : '';
            newDriverData.driverMobileNumber = sueData.customer.customerContactDetails[0] ? sueData.customer.customerContactDetails[0].number : '';
            newDriverData.driverPhoneNumber = sueData.customer.customerContactDetails[0] ? sueData.customer.customerContactDetails[0].number : '';
            newDriverData.driverOwnerRelation = '';
            newDriverData.driverLicenseNumber = sueData.customer.driverLicenseNumber;
            newDriverData.driverLicenseType = !sueData.customer.driverLicenseType || isNaN(sueData.customer.driverLicenseType) || sueData.customer.driverLicenseType == '' ? -1 : sueData.customer.driverLicenseType;
            newDriverData.driverLicensIssueDate = sueData.customer.driverLicensIssueDate;
        } else {
            newDriverData.driverFullName = sueData.driver && sueData.driver.driverFullName ? sueData.driver.driverFullName : '';
            newDriverData.driverIdentity = sueData.driver && sueData.driver.driverIdentity ? sueData.driver.driverIdentity : '';
            newDriverData.driverBirthDate = sueData.driver && sueData.driver.driverBirthDate ? sueData.driver.driverBirthDate : null;
            newDriverData.driverAddress = sueData.driver && sueData.driver.driverAddress ? sueData.driver.driverAddress : '';
            newDriverData.driverMobileNumber = sueData.driver && sueData.driver.driverMobileNumber ? sueData.driver.driverMobileNumber : '';
            newDriverData.driverPhoneNumber = sueData.driver && sueData.driver.driverPhoneNumber ? sueData.driver.driverPhoneNumber : '';
            newDriverData.driverOwnerRelation = sueData.driver && sueData.driver.driverOwnerRelation ? sueData.driver.driverOwnerRelation : '';
            newDriverData.driverLicenseNumber = sueData.driver && sueData.driver.driverLicenseNumber ? sueData.driver.driverLicenseNumber : '';
            newDriverData.driverLicenseType = sueData.driver && sueData.driver.driverLicenseType >= 0 ? sueData.driver.driverLicenseType : -1;
        }
        setDriver(newDriverData);

        sueCurrentData.driver = newDriverData;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onDriverParameterChange = async (e: any, paramName: string, isNumber: boolean = false) => {
        const newValue = e.target.value;
        const sueCurrentData = sueData;
        const driverData = sueData.driver ? sueData.driver : {};
        driverData[paramName] = newValue;
        setDriver(driverData);
        sueCurrentData.driver = driverData;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onIsIsraeliLicenseChange = (value: string) => {
        console.log('onIsIsraeliLicenseChange', value);
        const sueCurrentData = sueData;
        const driverData = sueCurrentData.driver ? sueCurrentData.driver : {};
        driverData.isIsraeliLicense = value;
        setDriver(driverData);
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onChangeGearType = (value: any) => {
        console.log('onChangeGearType', value);
        const sueCurrentData = sueData;
        const driverData = sueCurrentData.driver ? sueCurrentData.driver : {};
        driverData.vehicle.gearsType = value;
        sueCurrentData.vehicle.gearsType = value;
        setDriver(driverData);
        sueCurrentData.driver = driverData;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onChangeLicenseType = (value: any) => {
        console.log('onChangeLicenseType', value);
        const sueCurrentData = sueData;
        const driverData = sueCurrentData.driver ? sueCurrentData.driver : {};
        driverData.driverLicenseType = value;
        setDriver(driverData);
        sueCurrentData.driver = driverData;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onAddInvolvedVehicle = () => {
        const sueCurrentData = sueData;
        const involvedVehiclesList: any[] = sueCurrentData.involvedVehiclesList ? sueCurrentData.involvedVehiclesList : [];
        // const involvedVehicle = {
        //     isThirdPartyDefendantCompany: false,
        //     thirdPartySueNumber: '',
        //     thirdPartyLicensePlateNumber: '',
        //     thirdPartyCarModel: '',
        //     vehicleType: 0,
        //     thirdPartyInsuranceCompanyId: null,
        //     thirdPartyPolicyNumber: '',
        //     thirdPartyTypeOfVehicle: 0
        // }

        const involvedVehicle = {
            isThirdPartyDefendantCompany: false,
            thirdPartySueNumber: '',
            thirdPartyLicensePlateNumber: '',
            thirdPartyYear: '',
            thirdPartyCarModel: '',
            vehicleType: 0,
            thirdPartyInsuranceCompanyId: null,
            thirdPartyPolicyNumber: '',
            thirdPartyTypeOfVehicle: 0,
            thirdPartyAgentName: '',
            thirdPartyAgentPhone: '',
            thirdPartyCarOwnerMobile: '',
            thirdPartyCarOwnerPhone: '',
            thirdPartyPolicyName: '',
            thirdPartyCarOwnerName: '',
            thirdPartyOwnerIdentifier: '',
            thirdPartyOwnerAddress: '',
            isDriverOwnerOfTheVehicle: false,
            driverName: '',
            driverAddress: '',
            driverIdentifier: '',
            licenseNumber: '',
            driverPhone1: '',
            driverPhone2: ''
        }


        involvedVehiclesList.push(involvedVehicle);

        sueCurrentData.involvedVehiclesList = involvedVehiclesList;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onVehicleParameterChange = async (e: any, paramName: string, isNumber: boolean = false) => {
        const newValue = e.target.value;
        const sueCurrentData = sueData;
        const vehiclData = sueData.vehicle ? sueData.vehicle : {};
        if (paramName === 'name') {
            vehiclData['vehicleSubModel'].name = newValue;
        } else {
            vehiclData[paramName] = newValue;
        }
        console.log('onVehicleParameterChange-vehiclData', vehiclData)
        setDriver(vehiclData);
        sueCurrentData.vehicle = vehiclData;
        console.log('onVehicleParameterChange-sueCurrentData', sueCurrentData)
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onIsDefendantCompanyChange = async (value: string, option: { label: string; value: string; }, index: number = 0) => {
        const sueCurrentData = { ...sueData };
        const involvedVehiclesList: any[] = sueCurrentData.involvedVehiclesList ? sueCurrentData.involvedVehiclesList : [];
        const involvedVehicle = involvedVehiclesList[index] ? involvedVehiclesList[index] : {
            isThirdPartyDefendantCompany: false,
            thirdPartySueNumber: '',
            thirdPartyLicensePlateNumber: '',
            thirdPartyYear: '',
            thirdPartyCarModel: '',
            vehicleType: 0,
            thirdPartyInsuranceCompanyId: null,
            thirdPartyPolicyNumber: '',
            thirdPartyTypeOfVehicle: 0
        }

        involvedVehicle.isThirdPartyDefendantCompany = value == '1' ? true : false;
        if (!involvedVehiclesList[index]) {
            involvedVehiclesList.push(involvedVehicle);
        } else {
            involvedVehiclesList[index] = involvedVehicle;
        }
        sueCurrentData.involvedVehiclesList = involvedVehiclesList;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onTypeOfVehicleChange = async (value: string, option: { label: string; value: string; }, index: number = 0) => {
        const sueCurrentData = { ...sueData };
        const involvedVehiclesList: any[] = sueCurrentData.involvedVehiclesList ? sueCurrentData.involvedVehiclesList : [];
        const involvedVehicle = involvedVehiclesList[index] ? involvedVehiclesList[index] : {
            isThirdPartyDefendantCompany: false,
            thirdPartySueNumber: '',
            thirdPartyLicensePlateNumber: '',
            thirdPartyYear: '',
            thirdPartyCarModel: '',
            vehicleType: 0,
            thirdPartyInsuranceCompanyId: null,
            thirdPartyPolicyNumber: '',
            thirdPartyTypeOfVehicle: 0
        }

        involvedVehicle.thirdPartyTypeOfVehicle = parseInt(value);
        if (!involvedVehiclesList[index]) {
            involvedVehiclesList.push(involvedVehicle);
        } else {
            involvedVehiclesList[index] = involvedVehicle;
        }
        sueCurrentData.involvedVehiclesList = involvedVehiclesList;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onHandlingTypeChange = async (value: string) => {
        console.log('onHandlingTypeChange', value);
        const sueCurrentData = { ...sueData };
        sueCurrentData.handlingType = value;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onInvolvedVechicleCheck = (e: any, index: number = 0) => {
        const newValue = e.target.checked;
        const sueCurrentData = { ...sueData };
        const involvedVehiclesList: any[] = sueCurrentData.involvedVehiclesList ? [...sueCurrentData.involvedVehiclesList] : [];
        console.log('onInvolvedVechicleCheck-involvedVehiclesList', involvedVehiclesList)
        const involvedVehicle = involvedVehiclesList[index] ? involvedVehiclesList[index] : {
            isThirdPartyDefendantCompany: false,
            thirdPartySueNumber: '',
            thirdPartyLicensePlateNumber: '',
            thirdPartyYear: '',
            thirdPartyCarModel: '',
            vehicleType: 0,
            thirdPartyInsuranceCompanyId: null,
            thirdPartyPolicyNumber: '',
            thirdPartyTypeOfVehicle: 0
        }
        console.log('onInvolvedVechicleCheck-involvedVehicle', involvedVehicle)
        involvedVehicle.isDriverOwnerOfTheVehicle = newValue;
        if (!involvedVehiclesList[index]) {
            involvedVehiclesList.push({
                ...involvedVehicle,
                driverName: involvedVehicle.thirdPartyCarOwnerName,
                driverAddress: involvedVehicle.thirdPartyOwnerAddress,
                driverIdentifier: involvedVehicle.thirdPartyOwnerIdentifier,
                licenseNumber: involvedVehicle.thirdPartyLicensePlateNumber,
                driverPhone1: involvedVehicle.thirdPartyCarOwnerPhone,
                driverPhone2: involvedVehicle.thirdPartyCarOwnerMobile,
            });
        } else {
            involvedVehiclesList[index] = {
                ...involvedVehicle,
                driverName: involvedVehicle.thirdPartyCarOwnerName,
                driverAddress: involvedVehicle.thirdPartyOwnerAddress,
                driverIdentifier: involvedVehicle.thirdPartyOwnerIdentifier,
                licenseNumber: involvedVehicle.thirdPartyLicensePlateNumber,
                driverPhone1: involvedVehicle.thirdPartyCarOwnerPhone,
                driverPhone2: involvedVehicle.thirdPartyCarOwnerMobile,
            };
        }
        console.log('onInvolvedVechicleCheck-involvedVehiclesList-after', involvedVehiclesList)
        sueCurrentData.involvedVehiclesList = involvedVehiclesList;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onInvolvedVehicleChange = async (e: any, paramName: string, index: number, isNumber: boolean = false) => {
        console.log('onInvolvedVehicleChange', paramName, index, e.target.value);
        const newValue = e.target.value;
        const sueCurrentData = { ...sueData };
        const involvedVehiclesList = sueData.involvedVehiclesList ? sueData.involvedVehiclesList : [];
        if (!involvedVehiclesList[index]) {
            involvedVehiclesList.push({
                isThirdPartyDefendantCompany: false,
                thirdPartySueNumber: '',
                thirdPartyLicensePlateNumber: '',
                thirdPartyYear: '',
                thirdPartyCarModel: '',
                vehicleType: 0,
                thirdPartyInsuranceCompanyId: null,
                thirdPartyPolicyNumber: '',
                thirdPartyTypeOfVehicle: 0
            });
        }
        involvedVehiclesList[index][paramName] = newValue;
        sueCurrentData.involvedVehiclesList = involvedVehiclesList;

        console.log('onInvolvedVehicleChange', paramName, newValue, involvedVehiclesList[index]);
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onInvolvedVehicleTypeChange = async (value: string, paramName: string, index: number) => {
        console.log('onInvolvedVehicleTypeChange', value, paramName, index);
        const sueCurrentData = { ...sueData };
        const involvedVehiclesList: any[] = sueCurrentData.involvedVehiclesList ? sueCurrentData.involvedVehiclesList : [];
        if (!involvedVehiclesList[index]) {
            involvedVehiclesList.push({
                isThirdPartyDefendantCompany: false,
                thirdPartySueNumber: '',
                thirdPartyLicensePlateNumber: '',
                thirdPartyYear: '',
                thirdPartyCarModel: '',
                vehicleType: 0,
                thirdPartyInsuranceCompanyId: null,
                thirdPartyPolicyNumber: '',
                thirdPartyTypeOfVehicle: 0
            });
        }
        involvedVehiclesList[index][paramName] = parseInt(value);
        sueCurrentData.involvedVehiclesList = involvedVehiclesList;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
        console.log('onInvolvedVehicleTypeChange', value, paramName, index, involvedVehiclesList[index]);

    }


    const onInvolvedVehicleInsuranceCompanyChange = async (e: any, index: number = 0) => {
        const companyName = e.target.value;
        if (index == 0)
            setInvolvedVehicleInsuranceCompanyLabel(companyName);

        const sueCurrentData = { ...sueData };
        const involvedVehiclesListCopy: any[] = sueCurrentData.involvedVehiclesList ? sueCurrentData.involvedVehiclesList : [];
        console.log('onInvolvedVehicleInsuranceCompanyChange-involvedVehiclesListCopy', involvedVehiclesListCopy)

        console.log('onInvolvedVehicleInsuranceCompanyChange-involvedVehiclesListCopy[index]', involvedVehiclesListCopy[index])

        const involvedVehicle = { ...involvedVehiclesListCopy[index] }
        const selected = props.config.insuranceCompanies.find((a: any) => a.label == companyName);
        if (selected) {
            involvedVehicle.thirdPartyInsuranceCompanyId = selected.value;

            involvedVehiclesListCopy[index] = { ...involvedVehicle };

            sueCurrentData.involvedVehiclesList = [...involvedVehiclesListCopy];
            setSueData(sueCurrentData);
            console.log('onInvolvedVehicleInsuranceCompanyChange', selected, sueCurrentData)
        } else {

        }
    }

    const onClearInvolvedVehicleInsuranceCompany = (index: number = 0) => {
        if (index == 0) setInvolvedVehicleInsuranceCompanyLabel('');
        const sueCurrentData = { ...sueData };
        const involvedVehiclesList: any[] = sueCurrentData.involvedVehiclesList ? sueCurrentData.involvedVehiclesList : [];
        const involvedVehicle = involvedVehiclesList[index] ? involvedVehiclesList[index] : {
            isThirdPartyDefendantCompany: false,
            thirdPartySueNumber: '',
            thirdPartyLicensePlateNumber: '',
            thirdPartyYear: '',
            thirdPartyCarModel: '',
            vehicleType: 0,
            thirdPartyInsuranceCompanyId: null,
            thirdPartyPolicyNumber: '',
            thirdPartyTypeOfVehicle: 0
        }
        involvedVehicle.thirdPartyInsuranceCompanyId = null;
        if (!involvedVehiclesList[index]) {
            involvedVehiclesList.push(involvedVehicle);
        } else {
            involvedVehiclesList[index] = involvedVehicle;
        }
        sueCurrentData.involvedVehiclesList = involvedVehiclesList;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const createAccidentDamageObject = () => {
        return {
            "accidentDateTime": null,
            "isDriverLicensed": 0,
            "accidentAddress": "",
            "accidentDetails": "",
            "isPoliceNotified": false,
            "stationName": "",
            "caseNumber": "",
            "insuredCarDamageDescription": "",
            "thirdPartyCarDamageDescription": "",
            "booleanSelectList": null,
            "hours": null,
            "customerModel": null,
            "errors": []
        }
    }

    const onAccidentDamageParameterChange = async (e: any, paramName: string, isNumber: boolean = false) => {
        const newValue = e.target.value;
        const sueCurrentData = sueData;
        if (!sueCurrentData.sueAccidentAndDamageInfo) {
            sueCurrentData.sueAccidentAndDamageInfo = createAccidentDamageObject();
        }
        const sueAccidentAndDamageInfo = sueCurrentData.sueAccidentAndDamageInfo;

        sueAccidentAndDamageInfo[paramName] = newValue;
        sueCurrentData.sueAccidentAndDamageInfo = sueAccidentAndDamageInfo;
        console.log('onAccidentDamageParameterChange', sueCurrentData.sueAccidentAndDamageInfo);
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }


    const onAccidentDamageSelectChange = (newValue: string, paramName: string) => {
        const sueCurrentData = sueData;
        if (!sueCurrentData.sueAccidentAndDamageInfo) {
            sueCurrentData.sueAccidentAndDamageInfo = createAccidentDamageObject();
        }
        const sueAccidentAndDamageInfo = sueCurrentData.sueAccidentAndDamageInfo;
        switch (paramName) {
            case 'isPoliceNotified':
                sueAccidentAndDamageInfo.isPoliceNotified = newValue == '1';
                break;

            case 'isDriverLicensed':
                sueAccidentAndDamageInfo.isDriverLicensed = parseInt(newValue);
                break;
            default:
                sueAccidentAndDamageInfo[paramName] = newValue;
                break;
        }
        sueCurrentData.sueAccidentAndDamageInfo = sueAccidentAndDamageInfo;
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const onChangeParameter = async (e: any, paramName: string) => {

    }


    const onTimeChange = (time: any) => {
        // if (time == null) {
        //     time = dayjs('00:00', 'HH:mm');
        // }
        let hours: string = time.get('hour').toString();
        const sueCurrentData = sueData;
        if (parseInt(hours) < 10) {
            hours = `0${hours}`;
        }
        let minutes: string = time.get('minute').toString();
        if (parseInt(minutes) < 10) {
            minutes = `0${minutes}`;
        }
        let timeStr = hours + ':' + minutes;
        setAccidentTime(time);
        if (sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime) {
            let accidentDate = sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime ? moment(sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            accidentDate += " " + timeStr;
            const tz = "Asia/Jerusalem";
            sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime = new Date(moment(accidentDate).tz(tz).format('YYYY-MM-DDTHH:mm'));
            setSueData(sueCurrentData);
            setLastUpdate(moment().toDate());
        }
    };

    const onBlurTime = (e: any) => {
        let newTime = e.target.value;

        console.log('onBlurTime', newTime);
        if (newTime == null || newTime == '') {
            return;
        }
        newTime = newTime.replace(/(\d{2})(\d)/, '$1:$2');
        setAccidentTime(newTime);
        const sueCurrentData = sueData;
        if (newTime) {
            let accidentDate = sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime ? moment(sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
            accidentDate += "T" + newTime;
            const tz = "Asia/Jerusalem";
            sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime = new Date(moment(accidentDate).tz(tz).format('YYYY-MM-DDTHH:mm'));
            console.log('onBlurTime-sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime', sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime);

            setSueData(sueCurrentData);
            setLastUpdate(moment().toDate());
        }
    }

    const onChangeOpeningDate = async (date: any) => {
        console.log('onChangeOpeningDate-out', date)
        if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
            console.log('onChangeOpeningDate-inside', moment(date).toDate())
            const sueCurrentData = sueData;
            sueCurrentData.openingDate = moment(date).toDate();
            setOpeningDate(moment(date).toDate());
            await setSueData(sueCurrentData);
        } else {
            const sueCurrentData = sueData;
            sueCurrentData.openingDate = undefined;
            setOpeningDate(null);
            await setSueData(sueCurrentData);
        }
        setLastUpdate(moment().toDate());
    }

    const onChangeClosingDate = async (date: any) => {
        if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
            console.log('onChangeClosingDate', moment(date).toDate())
            const sueCurrentData = sueData;
            sueCurrentData.closingDate = moment(date).toDate();
            setClosingDate(moment(date).toDate());
            const newStatus = props.config.sueStatuses.find((a: any) => a.value == '2cd2f38a-0ab0-4c19-9568-b619a6da869f');
            if (newStatus) {
                sueCurrentData.sueStatusId = newStatus.value;
                setSueStatusLabel(newStatus.label);
            }
            await setSueData(sueCurrentData);
        } else {
            const sueCurrentData = sueData;
            sueCurrentData.closingDate = undefined;
            setClosingDate(null);
            await setSueData(sueCurrentData);
        }
        setLastUpdate(moment().toDate());
    }

    const onChangePaymentDate = async (date: any) => {
        if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
            console.log('onChangePaymentDate', moment(date).toDate())
            const sueCurrentData = sueData;
            sueCurrentData.paymentDate = moment(date).toDate();
            setPaymentDate(moment(date).toDate());
            await setSueData(sueCurrentData);
        } else {
            const sueCurrentData = sueData;
            sueCurrentData.paymentDate = undefined;
            setPaymentDate(null);
            await setSueData(sueCurrentData);
        }
        setLastUpdate(moment().toDate());
    }

    const onChangeCustomerCheckMaturityDate = async (date: any) => {
        if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
            console.log('onChangeCustomerCheckMaturityDate', moment(date).toDate())
            const sueCurrentData = sueData;
            sueCurrentData.customerCheckMaturityDate = moment(date).toDate();
            setCustomerCheckMaturityDate(moment(date).toDate());
            await setSueData(sueCurrentData);
        } else {
            const sueCurrentData = sueData;
            sueCurrentData.customerCheckMaturityDate = null;
            setCustomerCheckMaturityDate(null);
            await setSueData(sueCurrentData);
        }
        setLastUpdate(moment().toDate());
    }

    const onDateChange = async (name: string, date: Date) => {
        console.log('onDateChange', date);
        const sueCurrentData = sueData;
        switch (name) {
            case 'openingDate':
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    console.log('openingDate');
                    sueCurrentData.openingDate = date;
                    setOpeningDate(date);
                } else {
                    sueCurrentData.openingDate = undefined;
                    setOpeningDate(null);
                }
                break;
            case 'closingDate': {
                console.log('closingDate');
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    setClosingDate(date);
                    sueCurrentData.closingDate = date;
                    const newStatus = props.config.sueStatuses.find((a: any) => a.value == '2cd2f38a-0ab0-4c19-9568-b619a6da869f');
                    if (newStatus) {
                        sueCurrentData.sueStatusId = newStatus.value;
                        setSueStatusLabel(newStatus.label);
                    }
                    // 2cd2f38a-0ab0-4c19-9568-b619a6da869f
                } else {
                    sueCurrentData.closingDate = undefined;
                    setClosingDate(null)
                }
                break;
            }
            case 'paymentDate':
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    setPaymentDate(date);
                    sueCurrentData.paymentDate = date;
                } else {
                    sueCurrentData.paymentDate = undefined;
                    setPaymentDate(null)
                }
                break;
            case 'customerCheckMaturityDate': {
                // setCustomerCheckMaturityDate()
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    setCustomerCheckMaturityDate(date);
                    sueCurrentData.customerCheckMaturityDate = date;
                } else {
                    sueCurrentData.customerCheckMaturityDate = null;
                    setCustomerCheckMaturityDate(null)
                }
                break;
            }
            case 'accidentDateTime': {
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    setCustomerCheckMaturityDate(date);
                    setAccidentDate(moment(date).format('YYYY-MM-DD'));

                    if (!sueCurrentData.sueAccidentAndDamageInfo) {
                        sueCurrentData.sueAccidentAndDamageInfo = createAccidentDamageObject();
                    }
                    sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime = new Date(moment(date).format('YYYY-MM-DDTHH:mm'));
                    // const accidentTime = sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime ? moment(sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime).format('HH:mm') : '00:00'
                    // sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime = moment(`${moment(date).format('YYYY-MM-DD')} ${accidentTime}`).toDate();
                } else {
                    sueCurrentData.sueAccidentAndDamageInfo.accidentDateTime = undefined;
                    setCustomerCheckMaturityDate(null)
                }
                break;
            }
            case 'driverBirthDate': {
                const driverData = sueData.driver ? sueData.driver : {};
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    driverData.driverBirthDate = date;
                } else {
                    driverData.driverBirthDate = null;
                }
                setDriver(driverData);
                sueCurrentData.driver = driverData;
                setSueData(sueCurrentData);
                setLastUpdate(moment().toDate());
                break;
            }
            case 'driverLicensIssueDate': {
                const driverData = sueData.driver ? sueData.driver : {};
                if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
                    driverData.driverLicensIssueDate = date;
                } else {
                    driverData.driverLicensIssueDate = undefined;
                }
                setDriver(driverData);
                sueCurrentData.driver = driverData;
                setSueData(sueCurrentData);
                setLastUpdate(moment().toDate());
                break;
            }
            default:
                break;
        }
        await setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const getSueData = async () => {
        console.log('getSueData', sueData.id);
        const updatedData = await suesModel.suesGetById({ sueId: sueData.id });
        if (!updatedData) {
            return;
        }
        console.log('getSueData', updatedData);
        const sueCurrentData = sueData;
        sueCurrentData.documents = updatedData.documents;
        sueCurrentData.payments = updatedData.payments;
        if (updatedData.rider && updatedData.payments && updatedData.payments.length > 0) {
            updatedData.payments.sort((a: any, b: any) => b.createdDate - a.createdDate);
            sueCurrentData.requestedAmount = 0;
            sueCurrentData.approvedAmount = 0;
            updatedData.payments.forEach((p: any) => {
                sueCurrentData.requestedAmount += p.requestedAmount;
                sueCurrentData.approvedAmount += p.approvedAmount;
                sueCurrentData.paymentDate = p.bankTransferDate;
                setPaymentDate(p.bankTransferDate);
            });
        }
        setSuePaymentsList(updatedData.payments);
        setSueCommentsList(updatedData.sueComments);
        setSueTreatmentsList(updatedData.treatments);
        setSueDocumentList(updatedData.documents);
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const handleFileChange = async (event: any) => {
        const fileUploaded = event.target.files[0];
        const fileSize: string = (fileUploaded.size / 1024).toFixed(2);
        if (parseFloat(fileSize) > 5000) {
            return;
        }
        const reader = new FileReader();
        if (reader !== undefined && fileUploaded !== undefined) {
            reader.onloadend = async () => {
                const fileName = fileUploaded.name;
                setUploadFile({
                    path: fileName,
                    name: fileName,
                    size: fileSize,
                    comment: '',
                    file: reader.result,
                    createdDate: moment()
                });

            }
            reader.readAsDataURL(fileUploaded);
        }
    };

    const onFileCommentChange = (e: any) => {
        const newValue: string = e.target.value;
        setUploadFileComment(newValue);
    }

    const onAddFileClick = async () => {
        if (uploadFile !== null) {
            const newFile: any = {
                path: uploadFile.path,
                name: uploadFile.name,
                size: uploadFile.size,
                comment: uploadFileComment,
                file: uploadFile.file,
                createdDate: moment()
            }
            const sueCurrentData = sueData;
            sueCurrentData.documents.push(newFile);
            if (sueCurrentData.id) {
                await suesModel.sueFileUpload({
                    ...newFile,
                    sueId: sueCurrentData.id
                });
                await getSueData();
            } else {
                const files4Upload = [...filesForUpload];
                files4Upload.push({
                    ...newFile,
                    sueId: sueData.id
                });
                setFilesForUpload(files4Upload);
                setSueDocumentList(sueCurrentData.documents);
            }

            setUploadFile(null);
            setUploadFileComment('');
            setShowFileUpload(false);
        }
    }

    const onFileDelete = async (id: string) => {
        console.log('onFileDelete', id)
        await suesModel.sueDocumentDelete(id);
        if (!props.isPopUp) {
            setTimeout(async () => {
                await getSueData();
            }, 500)
        }
    }

    const onFileSelect = async (id: string) => {
        const selectedFile = sueData.documents.find((d: any) => d.id === id);
        if (selectedFile) {
            const fileUrl = `${apiUrl}${selectedFile.path}`;
            console.log('onFileSelect', fileUrl)
            setSelectedDocumentUrl(fileUrl);
        }
    }

    const onFileDownload = (id: string) => {
        const selectedFile = sueData.documents.find((d: any) => d.id === id);
        if (selectedFile) {
            if (apiUrl) {
                const fileUrl = `${apiUrl}${selectedFile.path}`;
                const anchor = document.createElement('a');
                anchor.href = fileUrl;
                anchor.target = '_blank';
                anchor.download = (moment().format('YYYYMMDDHHmm')) + 'filename.pdf'; // Set the filename you want
                document.body.appendChild(anchor);
                anchor.click();
                document.body.removeChild(anchor);
            }
        }
        // if(apiUrl !== '' && docUrl) {
        //     const fileUrl = `${apiUrl}${docUrl}`;
        //     console.log('downloadDocument', fileUrl );
        //     const anchor = document.createElement('a');
        //     anchor.href = fileUrl;
        //     anchor.target='_blank';
        //     anchor.download = 'filename.pdf'; // Set the filename you want
        //     document.body.appendChild(anchor);
        //     anchor.click();
        //     document.body.removeChild(anchor);
        // }
    }

    const addSueComment = async (commentData: any) => {
        await suesModel.treatmentsUpsertTreatment(commentData);
    }

    const onGarageParamChange = (e: any, paramName: string, onlyNumbers: boolean = false) => {
        const newValue: string = e.target.value;
        const sueCurrentData = sueData;
        const sueGarageDetails: any = garageDetails;
        sueGarageDetails[paramName] = onlyNumbers ? newValue.replace(/\D/g, "") : newValue;
        sueCurrentData.garageDetails = sueGarageDetails;
        setGarageDetails(sueGarageDetails);
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const handleButtonClick = () => {
        setShowFileUpload(true);
        // Programmatically click the hidden file input
        // if (fileInputRef.current) {
        //     fileInputRef.current.click();
        // }
    };

    const onGarageTidyUpChange = (value: string) => {
        const sueCurrentData = sueData;
        const sueGarageDetails: any = garageDetails;
        garageDetails.garageDetails = value == '1';
        sueCurrentData.garageDetails = sueGarageDetails;
        setGarageDetails(sueGarageDetails);
        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }

    const validateData = (newSueData: any) => {
        const errors = { ...formErrors };
        let hasErrors = false;

        if (!newSueData.id && !newSueData.sueStatusId) {
            errors.status = true;
        } else {
            errors.status = false;
        }
        // policyNumber
        if (newSueData.policy) {
            if (!newSueData.policy.policyNumber || newSueData.policy.policyNumber === '') {
                errors.policyNumber = hasErrors = true;
            } else {
                errors.policyNumber = false;
            }
        }
        if (newSueData.rider) {
            if (!newSueData.rider.subscriberNumber || newSueData.rider.subscriberNumber === '') {
                errors.policyNumber = hasErrors = true;
            } else {
                errors.policyNumber = false;
            }
        }

        // sueType
        if (!newSueData.sueTypeId || newSueData.sueTypeId === '') {
            errors.sueType = hasErrors = true;
        } else {
            errors.sueType = false;
        }

        // handlerId
        if (!newSueData.handlerId) {
            errors.sueHandler = hasErrors = true;
        } else {
            errors.sueHandler = false;
        }

        // openingDate
        if (!newSueData.openingDate || !moment(newSueData.openingDate).isValid()) {
            errors.openingDate = hasErrors = true;
        } else {
            errors.openingDate = false;
        }

        // activityStatus
        if (!newSueData.sueActivityStatusId || newSueData.sueActivityStatusId == '') {
            errors.activityStatus = hasErrors = true;
        } else {
            errors.activityStatus = false;
        }
        // insuranceCompany
        if (!newSueData.insuranceCompany && !sueData.rider) {
            errors.insuranceCompany = hasErrors = true;
        } else {
            errors.insuranceCompany = false;
        }

        if (newSueData.sueStatusId === "0352e030-455b-46e9-9d4e-c9e73707f921") {
            if (newSueData.approvedAmount === null || newSueData.approvedAmount === undefined || newSueData.approvedAmount === '') {
                console.log('onSave-newSueData.approvedAmount', newSueData.approvedAmount, newSueData.approvedAmount === null || newSueData.approvedAmount === undefined || newSueData.approvedAmount == '')
                errors.approvedAmountPayment = true;
                hasErrors = true;
            } else {
                errors.approvedAmountPayment = false;
            }
        }

        setFormErrors(errors);
        return hasErrors;
    }

    const getHistoryActivitiesForSave = (dataForSave: any) => {
        let history = '';
        Object.keys(dataForSave).forEach((k: string) => {
            console.log('getHistoryActivitiesForSave-k', k)
            switch (k) {
                case 'sueNumber': {
                    if (sueDataOrig.sueNumber != null && dataForSave.sueNumber !== sueDataOrig.sueNumber) {
                        if (history !== '') {
                            history += " \n";
                        }
                        history += `עודכן מס' תביעה ${sueDataOrig.sueNumber} ל-${dataForSave.sueNumber}`;
                    }
                    break;
                }
                case 'sueTypeId': {
                    if (sueDataOrig.sueTypeId != null && dataForSave.sueTypeId !== sueDataOrig.sueTypeId) {
                        const prevData = props.config.sueTypes.find((a: any) => a.value == sueDataOrig.sueTypeId);
                        const currData = props.config.sueTypes.find((a: any) => a.value == dataForSave.sueTypeId);
                        if (currData && prevData) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `סוג תביעה עודכן מ-${prevData.label} ל-${currData.label}`;
                        }
                    }
                    break;
                }
                case 'sueActivityStatusId': {
                    if (sueDataOrig.sueActivityStatusId != null && dataForSave.sueActivityStatusId != sueDataOrig.sueActivityStatusId) {
                        const prevData = props.config.sueActivityStatuses.find((a: any) => a.value == sueDataOrig.sueActivityStatusId);
                        const currData = props.config.sueActivityStatuses.find((a: any) => a.value == dataForSave.sueActivityStatusId);
                        if (currData && prevData) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `מצב תביעה עודכן מ-${prevData.label} ל-${currData.label}`;
                        }
                    }
                    break;
                }
                case 'sueStatusId': {
                    if (sueDataOrig.sueStatusId != null && dataForSave.sueStatusId != sueDataOrig.sueStatusId) {
                        const prevData = props.config.sueStatuses.find((a: any) => a.value == sueDataOrig.sueStatusId);
                        const currData = props.config.sueStatuses.find((a: any) => a.value == dataForSave.sueStatusId);
                        if (currData && prevData) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `סטטוס תביעה עודכן מ-${prevData.label} ל-${currData.label}`;
                        }
                    }
                    break;
                }
                case 'handlerId': {
                    if (sueDataOrig.handlerId != null && dataForSave.handlerId != sueDataOrig.handlerId) {
                        const prevData = props.config.handlers.find((a: any) => a.value == sueDataOrig.handlerId);
                        const currData = props.config.handlers.find((a: any) => a.value == dataForSave.handlerId);
                        if (currData && prevData) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `מטפל בתביעה עודכן מ-${prevData.label} ל-${currData.label}`;
                        }
                    }
                    break;
                }
                case 'requestedAmount': {
                    if (Number(dataForSave.requestedAmount) != Number(sueDataOrig.requestedAmount)) {
                        if (history !== '') {
                            history += " \n";
                        }
                        history += `סכום שנתבע עודכן מ-${sueDataOrig.requestedAmount} ל-${dataForSave.requestedAmount}`;
                    }
                    break;
                }
                case 'approvedAmount': {
                    if (dataForSave.approvedAmount !== sueDataOrig.approvedAmount) {
                        if (history !== '') {
                            history += " \n";
                        }
                        history += `סכום שאושר עודכן מ-${sueDataOrig.approvedAmount} ל-${dataForSave.approvedAmount}`;
                    }
                    break;
                }
                case 'sueNumber': {
                    if (dataForSave.sueNumber !== sueDataOrig.sueNumber) {
                        if (history !== '') {
                            history += " \n";
                        }
                        history += `עודכן מס' תביעה ${sueDataOrig.sueNumber} ל-${dataForSave.sueNumber}`;
                    }
                    break;
                }
                case 'damageAppraiser': {
                    if (dataForSave.damageAppraiser !== sueDataOrig.damageAppraiser) {
                        if (history !== '') {
                            history += " \n";
                        }
                        history += `עודכן נזק עפ"י שמאי ${sueDataOrig.damageAppraiser} ל-${dataForSave.damageAppraiser}`;
                    }
                    break;
                }
                case 'impairment': {
                    if (dataForSave.impairment !== sueDataOrig.impairment) {
                        if (history !== '') {
                            history += " \n";
                        }
                        history += `עודכן ירידת ערך ${sueDataOrig.impairment} ל-${dataForSave.impairment}`;
                    }
                    break;
                }

                default:
                    break;
            }
        });

        if (dataForSave.driver && sueDataOrig.driver) {
            if (dataForSave.driver.driverFullName !== sueDataOrig.driver.driverFullName) {
                if (history !== '') {
                    history += " \n";
                }
                history += `עודכן שם הנהג ל-${dataForSave.driver.driverFullName}`;
            }
        }

        if (dataForSave.garageDetails && sueDataOrig.garageDetails) {
            Object.keys(dataForSave.garageDetails).forEach((k: string) => {
                switch (k) {
                    case 'assessorName': {
                        if (dataForSave.garageDetails.assessorName !== sueDataOrig.garageDetails.assessorName) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `עודכן שמו של השמאי ${dataForSave.garageDetails.assessorName}`;
                        }

                        break;
                    }
                    case 'garageName': {
                        if (dataForSave.garageDetails.garageName !== sueDataOrig.garageDetails.garageName) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `עודכן שם המוסך ${dataForSave.garageDetails.garageName}`;
                        }
                        break;
                    }
                    default:
                        break;
                }
            })
        }
        if (dataForSave.sueAccidentAndDamageInfo && sueDataOrig.sueAccidentAndDamageInfo) {
            Object.keys(dataForSave.sueAccidentAndDamageInfo).forEach((k: string) => {
                switch (k) {
                    case 'accidentDateTime': {
                        if (dataForSave.sueAccidentAndDamageInfo.accidentDateTime && sueDataOrig.sueAccidentAndDamageInfo.accidentDateTime) {
                            if (moment(dataForSave.sueAccidentAndDamageInfo.accidentDateTime).format('YYYY-MM-DD HH:mm') !== moment(sueDataOrig.sueAccidentAndDamageInfo.accidentDateTime).format('YYYY-MM-DD HH:mm')) {
                                if (history !== '') {
                                    history += " \n";
                                }
                                history += `עודכן תאריך ושעת האירוע מ-${moment(sueDataOrig.sueAccidentAndDamageInfo.accidentDateTime).format('DD/MM/YYYY HH:mm')} ל-${moment(dataForSave.sueAccidentAndDamageInfo.accidentDateTime).format('DD/MM/YYYY HH:mm')}`;
                            }
                        }
                        break;
                    }
                    case 'accidentAddress': {
                        if (dataForSave.sueAccidentAndDamageInfo.accidentAddress !== sueDataOrig.sueAccidentAndDamageInfo.accidentAddress) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `עודכן כתובת האירוע מ-${sueDataOrig.sueAccidentAndDamageInfo.accidentAddress} ל-${dataForSave.sueAccidentAndDamageInfo.accidentAddress}`;
                        }
                        break;
                    }
                    case 'accidentDetails': {
                        if (dataForSave.sueAccidentAndDamageInfo.accidentDetails !== sueDataOrig.sueAccidentAndDamageInfo.accidentDetails) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `עודכן פרטי האירוע מ-${sueDataOrig.sueAccidentAndDamageInfo.accidentDetails} ל-${dataForSave.sueAccidentAndDamageInfo.accidentDetails}`;
                        }
                        break;
                    }
                    case 'insuredCarDamageDescription': {
                        if (dataForSave.sueAccidentAndDamageInfo.insuredCarDamageDescription !== sueDataOrig.sueAccidentAndDamageInfo.insuredCarDamageDescription) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `עודכן נזק לרכב המבוטח מ-${sueDataOrig.sueAccidentAndDamageInfo.insuredCarDamageDescription} ל-${dataForSave.sueAccidentAndDamageInfo.insuredCarDamageDescription}`;
                        }
                        break;
                    }
                    case 'thirdPartyCarDamageDescription': {
                        if (dataForSave.sueAccidentAndDamageInfo.thirdPartyCarDamageDescription !== sueDataOrig.sueAccidentAndDamageInfo.thirdPartyCarDamageDescription) {
                            if (history !== '') {
                                history += " \n";
                            }
                            history += `עודכן נזק לרכב צד ג מ-${sueDataOrig.sueAccidentAndDamageInfo.thirdPartyCarDamageDescription} ל-${dataForSave.sueAccidentAndDamageInfo.thirdPartyCarDamageDescription}`;
                        }
                        break;
                    }
                    default:
                        break;
                }
            })
        }
        return history;
    }

    const onSaveClick = async () => {
        const hasErrors = validateData(sueData);
        if (hasErrors) {
            setShowErrorFieldsWarning(true);
            return;
        }
        let sueId = sueData.id;

        const dataForSave = { ...sueData }

        if (dataForSave.closingDate == null) {
            dataForSave.closingDate = undefined;
        }

        if (dataForSave.driver) {
            dataForSave.driver.isIsraeliLicense = dataForSave.driver.isIsraeliLicense == '1';
        }
        if (!sueId) {
            dataForSave.documents = [];
            if (!dataForSave.creatorUserId) {
                const savedLoggedUser = localStorage.getItem('loggedUser');
                if (savedLoggedUser) {
                    const loggedUser = JSON.parse(savedLoggedUser);
                    if (loggedUser && loggedUser.id) {
                        dataForSave.creatorUserId = loggedUser.id;
                    }
                }
            }
        }

        // set comment in dataForSave
        if (newSueComment.comment && newSueComment.comment.length > 0) {
            dataForSave.comments = newSueComment.comment
        }

        console.log('dataForSave-first', dataForSave)
        const result = await onSaveSue(dataForSave);

        if (result.status && result.status == 400) {
            if (result.errors) {
                let errorMsg = '';
                console.log('result.errors', result.errors)
                Object.keys(result.errors).forEach((erKey: any, index: number) => {

                    if (erKey.indexOf('Policy') >= 0) {
                        errorMsg += `<div><strong>פרטי פוליסה:</strong>${result.errors[erKey][0]}</div>`;
                        console.log('פרטי פוליסה:', result.errors[erKey][0]);
                    } else if (erKey.indexOf('Vhicle') >= 0) {
                        errorMsg += `<div><strong>פרטי רכב:</strong>${result.errors[erKey][0]}</div>`;
                        console.log('פרטי רכב:', result.errors[erKey][0]);
                    } else if (erKey.indexOf('Driver') >= 0) {
                        errorMsg += `<div><strong>פרטי נהג:</strong>${result.errors[erKey][0]}</div>`;
                        console.log('פרטי נהג:', result.errors[erKey][0]);
                    } else if (erKey.indexOf('Customer') >= 0) {
                        errorMsg += `<div><strong>פרטי לקוח:</strong>${result.errors[erKey][0]}</div>`;
                        console.log('פרטי לקוח:', result.errors[erKey][0]);
                    }

                });
                if (errorMsg !== '' && props.config.showMessagePopup) {
                    props.config.showMessagePopup(errorMsg);
                }
            }
        } else {
            console.log('result.label', result)
            if (result.label === "התביעה נוצרה בהצלחה!" || result.label === "התביעה עודכנה בהצלחה!") {
                // setShowConfirmationPopup(true);
                if (props.onRelaodAfterSaveSue) {
                    console.log('dataForSave-second', dataForSave)
                    await props.onRelaodAfterSaveSue(dataForSave);
                }
            }

            const history = getHistoryActivitiesForSave(dataForSave);

            console.log('dataForSave.id', dataForSave)

            if (dataForSave.id && history && history.length > 0) {
                const commentData = {
                    "TreatmentType": 4,
                    "AlertDate": null,
                    "Topic": !dataForSave.id ? "תביעה הוקמה" : "תביעה עודכנה",
                    "SueRelatedId": sueId,
                    "EmailBody": history

                }
                await addSueComment(commentData);
            }


            if (result.val !== "00000000-0000-0000-0000-000000000000") {
                const sueCurrentData = dataForSave;
                sueCurrentData.id = result.val;
                setSueData(sueCurrentData);
                sueId = result.val;
            }

            if (filesForUpload.length > 0 && sueId) {
                filesForUpload.forEach(async (f: any) => {
                    console.log(f);
                    await suesModel.sueFileUpload({
                        sueId: sueId,
                        name: f.name,
                        file: f.file
                    });
                })
            }


            if (suePaymentsList && suePaymentsList.length > 0) {
                suePaymentsList.forEach(async (p: any) => {
                    if (!p.sueId) {
                        const paymentData = {
                            ...p,
                            sueId: sueId
                        }
                        await addPayment(paymentData);
                    }
                })
            }

            if (sueCommentsList && sueCommentsList.length > 0) {
                sueCommentsList.forEach(async (c: any) => {
                    let sueId = dataForSave.id;
                    if (!c.sueId) {
                        c.sueId = sueId;
                        await addComment(c);
                    }
                })
            }

            if (!props.isPopUp) {
            }
            dispatch(setReloadSuesData(true))
            props.config.closeTab(props.customerId);
        }
    }

    const onCloseClick = () => {
        // console.log('close')
        // props.config.closeTab();
        setShowConfirmationPopup(true);
    }

    const onCloseSueDetails = () => {
        setShowConfirmationPopup(false);

        console.log('props.config.closeTab', 123)
        if (props.cancelAddClaimPoopup) {
            props.cancelAddClaimPoopup();
        } else {
            props.config.closeTab(props.customerId);
        }
    }

    const onHideDocumentPopUp = () => {
        setSelectedDocumentUrl(null)
        setClientDocumentUrl(null);
    }

    const onSueNewPaymentDateChange = (date: any) => {
        const payment: any = { ...newSuePayment };
        if (moment(date).isValid() && moment(date).format('YYYY-MM-DD') !== '0001-01-01') {
            payment.createdDate = date;
            payment.bankTransferDate = date;
        } else {
            payment.createdDate = payment.bankTransferDate = undefined;
        }
        setNewSuePayment(payment);
    }

    const onSueNewPaymentChange = (e: any, name: string, onlyNumbers?: boolean) => {
        console.log('onSueNewPaymentChange', e.target.value)

        const newValue: string = e.target.value;
        console.log('onSueNewPaymentChange-newValue', newValue)
        const payment: any = { ...newSuePayment };
        payment[name] = onlyNumbers ? newValue.replace(/\D/g, "") : newValue;
        setNewSuePayment(payment);
    }

    const addPayment = async (data: any) => {
        // createdDate: newSuePayment.createdDate,
        // updatedDate: newSuePayment.createdDate,
        // title: newSuePayment.title,
        // supplier: newSuePayment.supplier,
        // approvedAmount: newSuePayment.approvedAmount,
        // claimedAmount : newSuePayment.claimedAmount ,
        await suesModel.addSuePayment({
            title: data.title,
            createdDate: data.createdDate,
            updatedDate: data.createdDate,
            amount: data.requestedAmount,
            supplier: data.supplier,
            approvedAmount: data.approvedAmount,
            bankTransferDate: data.bankTransferDate,
            requestedAmount: data.requestedAmount,
            sueId: data.sueId
        });

        // const commentData = {
        //     "TreatmentType": 4,
        //     "AlertDate": null,
        //     "Topic": 'תשלום נאסף: ' + data.requestedAmount,
        //     "SueRelatedId": data.sueId
        // }

        // await addSueComment(commentData);
    }


    const onSueNewCommentChange = (e: any, name: string, onlyNumbers?: boolean) => {
        const newValue: string = e.target.value;
        const comment: any = { ...newSueComment };
        comment[name] = onlyNumbers ? newValue.replace(/\D/g, "") : newValue;
        console.log('onSueNewCommentChange', comment);
        setNewSueComment(comment);
    }

    const onSueAddComment = async () => {
        const comment: any = { ...newSueComment };
        let sueId = sueData.id;
        if (sueId) {
            comment.sueId = sueData.id;
            await addComment(comment);
            setTimeout(async () => {
                await getSueData();
            }, 500)
        }
        const comments = [...sueCommentsList];
        comments.push(comment);
        setSueCommentsList(comments);

        setNewSueComment({
            comment: ''
        });
    }

    const addComment = async (data: any) => {
        const savedLoggedUser = localStorage.getItem('loggedUser');
        if (savedLoggedUser) {
            const loggedUser = JSON.parse(savedLoggedUser);
            await suesModel.addSueComment({
                comment: data.comment,
                userId: loggedUser.id,
                sueId: data.sueId
            });
            // const commentData = {
            //     "TreatmentType": 4,
            //     "AlertDate": null,
            //     "Topic": 'הערה נאספה: ' + data.comment,
            //     "SueRelatedId": data.sueId
            // }
            // await addSueComment(commentData);
        }
    }

    const onSueAddPayment = async () => {
        console.log('onSueAddPayment-newSuePayment', newSuePayment);
        if (parseFloat(newSuePayment.requestedAmount) > 0 && parseFloat(newSuePayment.approvedAmount) > 0 && moment(newSuePayment.createdDate).isValid()) {
            let sueId = sueData.id;
            console.log('onSueAddPayment-sueId', sueId);
            const suePayments = suePaymentsList;
            if (sueId) {
                suePayments.push({
                    createdDate: newSuePayment.createdDate,
                    updatedDate: newSuePayment.createdDate,
                    bankTransferDate: newSuePayment.createdDate,
                    title: newSuePayment.title,
                    supplier: newSuePayment.supplier,
                    approvedAmount: newSuePayment.approvedAmount,
                    requestedAmount: newSuePayment.requestedAmount,
                    amount: newSuePayment.requestedAmount,
                    sueId: sueId
                });
                console.log('onSueAddPayment-newSuePayment', suePayments);

                setSuePaymentsList(suePayments);
                // await addPayment(paymentData);
                addPaymentToSum()
                // setTimeout(async()=>{
                //     await getSueData();
                // }, 500)
            } else {
                suePayments.push({
                    createdDate: newSuePayment.createdDate,
                    updatedDate: newSuePayment.createdDate,
                    bankTransferDate: newSuePayment.createdDate,
                    title: newSuePayment.title,
                    supplier: newSuePayment.supplier,
                    approvedAmount: newSuePayment.approvedAmount,
                    requestedAmount: newSuePayment.requestedAmount,
                    amount: newSuePayment.requestedAmount,
                })
                setSuePaymentsList(suePayments);
                addPaymentToSum()
            }
            setNewSuePayment({
                requestedAmount: null,
                approvedAmount: null,
                createdDate: null,
                bankTransferDate: null,
                supplier: '',
                title: '',
            });
            setShowNewPayment(false);
        }
    }

    const addPaymentToSum = () => {
        const sueCurrentData = { ...sueData };
        sueCurrentData.requestedAmount = 0;
        sueCurrentData.approvedAmount = 0;
        suePaymentsList.forEach((p: any) => {
            sueCurrentData.requestedAmount += Number(p.requestedAmount);
            sueCurrentData.approvedAmount += Number(p.approvedAmount);
        });
        // set the latest bankTransferDate in sueData from suePaymentsList
        let latestDate: any = null;
        suePaymentsList.forEach((p: any) => {
            if (p.bankTransferDate) {
                if (!latestDate) {
                    latestDate = p.bankTransferDate;
                } else {
                    if (moment(p.bankTransferDate).isAfter(moment(latestDate))) {
                        latestDate = p.bankTransferDate;
                    }
                }
            }
        });
        console.log('addPaymentToSum-paymentDate', sueCurrentData.paymentDate, latestDate)
        sueCurrentData.paymentDate = moment(latestDate).format('YYYY-MM-DDTHH:mm:ss');
        setPaymentDate(latestDate);

        setSueData(sueCurrentData);
        setLastUpdate(moment().toDate());
    }



    const onSueNewTreatmentChange = (e: any, name: string, onlyNumbers?: boolean) => {
        const newValue: string = e.target.value;
        const treatment: any = { ...newTreatment };
        treatment[name] = onlyNumbers ? newValue.replace(/\D/g, "") : newValue;
        setNewTreatment(treatment);
    }
    const onSueAddTreatment = async () => {
        if (newTreatment.topic == '') {
            return;
        }
        let sueId = sueData.id;
        const commentData: any = {
            treatmentType: 4,
            alertDate: null,
            topic: newTreatment.topic
        }
        if (sueId) {
            commentData.sueRelatedId = sueId;
            await addSueComment(commentData);
            setTimeout(async () => {
                await getSueData();
            }, 500)
        } else {

        }
        const treatments = [...sueTreatmentsList];
        treatments.push(commentData)
        setSueTreatmentsList(treatments);
        const treatment: any = { ...newTreatment };
        treatment.topic = '';
        setNewTreatment(treatment);
        setLastUpdate(moment().toDate());
    }

    const onAddOfferOptionClick = (type: number) => {
        if (props.config.showAddTreatmentPopup) {
            console.log('onAddOfferOptionClick-sueData.customerId', sueData.customerId)
            props.config.showAddTreatmentPopup(type, sueData.customerId);
        }
    }

    const getThirdPartyVehicleTypeValue = (vehicleTypeId: number) => {
        const vehicleType = typeOfCars.find((v: any) => v.value === vehicleTypeId);
        if (vehicleType) {
            return vehicleType.label;
        }
        return '';
    }

    // const addOfferOptions: MenuProps['items'] = [
    //     {
    //         key: '1',
    //         label:
    //             <li className="pointer rtl"
    //                 onClick={() => { onAddOfferOptionClick(TreatmentType._1) }}
    //             >
    //                 משימה
    //             </li>,
    //     },
    //     {
    //         key: '2',
    //         label:
    //             <li className="pointer rtl"
    //                 onClick={() => { onAddOfferOptionClick(TreatmentType._2) }}
    //             >
    //                 וואצפ
    //             </li>,
    //     },
    //     {
    //         key: '3',
    //         label:
    //             <div className="pointer rtl"
    //                 onClick={() => { onAddOfferOptionClick(TreatmentType._3) }}
    //             >
    //                 תיעוד דוא"ל
    //             </div>,
    //     },
    //     {
    //         key: '4',
    //         label:
    //             <li className="pointer rtl"
    //                 onClick={() => { onAddOfferOptionClick(TreatmentType._4) }}
    //             >
    //                 תיעוד
    //             </li>,
    //     }

    // ];

    useEffect(() => {
        const aUrl = localStorage.getItem('apiUrl');
        if (apiUrl == '' && aUrl) {
            setApiUrl(aUrl);
        }
        if (props.tabData) {
            // setItemData(props.tabData);
            const sueDataFromProps = _.cloneDeep(props.tabData.sueData);

            // if (!sueData.sueStatusId) {
            //     sueData.sueStatusId = 'bc1a434f-c4a4-4899-b99c-daf3f0b5e9a3';
            // }
            setSueData(sueDataFromProps);

            const policyData = sueDataFromProps.policy;
            const vehicleData = sueDataFromProps.vehicle ? sueDataFromProps.vehicle : sueDataFromProps.driver && sueDataFromProps.driver.vehicle ? sueDataFromProps.driver.vehicle : null;
            const customerData = sueDataFromProps.customer;
            const ownerCustomer = sueDataFromProps.customer;
            if (ownerCustomer && ownerCustomer.customerContactDetails && ownerCustomer.customerContactDetails.length > 0) {
                setCustomerPhone(ownerCustomer.customerContactDetails[0].number);
                if (ownerCustomer.customerContactDetails[1]) {
                    setCustomerAdditionalPhone(ownerCustomer.customerContactDetails[1].number);
                } else {
                    setCustomerAdditionalPhone('');
                }
            } else {
                setCustomerPhone('');
                setCustomerAdditionalPhone('');
            }
            const gendersList = props.config.genders;
            if (customerData && customerData.gender > -1) {
                const selectedGender = gendersList.find((g: any) => g.value == customerData.gender);
                if (selectedGender) {
                    setGender(selectedGender.label);
                }
            }
            if (customerData && customerData.customerAddresses && customerData.customerAddresses.length > 0) {
                setAddress(customerData.customerAddresses[0]);
            }

            if (customerData && customerData.customerContactDetails && customerData.customerContactDetails.length > 0) {
                setCustomerEmail(customerData.customerContactDetails[0].emailAddress)
                // setAddress(customerData.customerContactDetails[0]);
            }

            if (vehicleData && props.tabData.vehicleOwnerships) {
                const selectedOwnership = props.tabData.vehicleOwnerships.find((vo: any) => vo.id === vehicleData.vehicleOwnership);
                if (selectedOwnership) {
                    setVehicleOwnership(selectedOwnership.name);
                }
            }
            // console.log('set modelCode', sueDataFromProps)
            // if(sueDataFromProps.rider == null && sueDataFromProps.vehicle && (!sueDataFromProps.vehicle.modelCode || sueDataFromProps.vehicle.modelCode == '' || sueDataFromProps.vehicle.modelCode == '0') && sueDataFromProps.policy.policyType && sueDataFromProps.policy.policyType.policyTypeId == '9' ) {
            //     vehicleData.modelCode = '00000';
            //     console.log('set modelCode to 00000 for vehicle', sueDataFromProps.vehicle.modelCode)
            //     // sueDataFromProps.vehicle.modelCode = '00000';
            // } else{
            //     console.log('modelCode is valid', sueDataFromProps.vehicle )
            //     console.log('modelCode is valid', sueDataFromProps.policy)
            // }
            setVehicleData(vehicleData);
            setCustomer(ownerCustomer);
            if (policyData) {
                setPolicyNumber(sueDataFromProps.policy.policyNumber);
                const policiType: number = sueDataFromProps.policy.policyType ? sueDataFromProps.policy.policyType.policyTypeId : 2;
                setPolicyTypeId(policiType == 9 ? 1 : policiType);
                // setPolicyTypeId(1);
                if ([4, 5, 22].includes(policiType)) {
                    setShowLessTabs(true);
                }

                switch (policiType) {
                    case 1:
                    case 9: {
                        const sTypes: any[] = sueTypes.filter((t: any) => t.policyTypeId == '96e4eede-586d-4a82-ae29-6ca3e2c65625')
                        setSueTypes(sTypes)
                        break;
                    }
                    // case 2:{
                    //     const sTypes: any[] = sueTypes.filter((t: any)=>t.policyTypeId == null)
                    //     setSueTypes(sTypes)
                    //     break;
                    // }
                    // case 3:{
                    //     const sTypes: any[] = sueTypes.filter((t: any)=>t.policyTypeId == "40f871f2-9fc0-4dc5-9c4f-5c738303863a")
                    //     setSueTypes(sTypes)
                    //     break;
                    // }
                    default:
                        const sTypes: any[] = sueTypes.filter((t: any) => t.policyTypeId == null)
                        setSueTypes(sTypes)
                        break;
                        break;
                }

                // setSueTypes

            } else {
                if (sueDataFromProps.rider) {
                    setPolicyNumber(sueDataFromProps.rider.subscriberNumber);
                    setPolicyTypeId(1);
                    const sTypes: any[] = sueTypes.filter((t: any) => t.policyTypeId != null)
                    setSueTypes(sTypes)
                }
            }
            if (sueDataFromProps.elementaryPolicyStatusId) {
                setStatusId(sueDataFromProps.elementaryPolicyStatusId);
                const selectedStatus = props.tabData.statuses.find((s: any) => s.value === sueDataFromProps.elementaryPolicyStatusId);
                if (selectedStatus) {
                    setStatus(selectedStatus.label)
                }
            }
            if (sueDataFromProps.insuranceCompanyId) {
                const selectedInsuranceCompany = props.config.insuranceCompanies.find((a: any) => a.value == sueDataFromProps.insuranceCompanyId);
                if (selectedInsuranceCompany) {
                    setInsuranceCompanyLabel(selectedInsuranceCompany.label);
                }
            } else {
                if (sueDataFromProps.rider) {
                    setInsuranceCompanyLabel('פלוס שירותי דרך');
                }
            }

            if (sueDataFromProps.elementaryPolicy && sueDataFromProps.elementaryPolicy.elementaryPolicyDocuments && sueDataFromProps.elementaryPolicy.elementaryPolicyDocuments.length > 0) {
                setDocumentsList(sueDataFromProps.elementaryPolicy.elementaryPolicyDocuments);
            }

            if (sueDataFromProps.involvedVehiclesList && sueDataFromProps.involvedVehiclesList.length > 0) {
                if (sueDataFromProps.involvedVehiclesList[0].thirdPartyInsuranceCompanyId) {
                    const selectedInsuranceCompany = props.config.insuranceCompanies.find((a: any) => a.value == sueDataFromProps.involvedVehiclesList[0].thirdPartyInsuranceCompanyId);
                    if (selectedInsuranceCompany) {
                        setInvolvedVehicleInsuranceCompanyLabel(selectedInsuranceCompany.label);
                    }
                }
            }
            if (sueDataFromProps.garageDetails && sueDataFromProps.garageDetails.garageName !== '') {
                setSueGarageLabel(sueDataFromProps.garageDetails.garageName);
            }
            switch (sueDataFromProps.driversType) {
                case 0:
                    setDriversType('נהג אחד')
                    break;
                case 1:
                    setDriversType('שני נהגים')
                    break;
                case 2:
                    setDriversType('כל נהג')
                    break;

                default:
                    break;
            }

            setSueInternalNumber(sueDataFromProps.internalNumber && sueDataFromProps.internalNumber > 0 ? sueDataFromProps.internalNumber : '');

            console.log('SueItemUpdate', sueDataFromProps);

            init(sueDataFromProps);
        }
    }, []);

    useEffect(() => {
            if (fileDocumentsUrl) {
                setClientDocumentUrl(fileDocumentsUrl);
                dispatch(setFileDocumentsUrl(null));
            }
    },[fileDocumentsUrl])

    // useEffect(() => {
    //     if (sueTreatmentsList && sueTreatmentsList.length > 0 && creatorsList && creatorsList.length >0) {
    //         const treatments = [...sueTreatmentsList];
    //         treatments.forEach((t: any)=>{
    //             t.userName = getCreatorNameById(t.userId);
    //         });
    //         setSueTreatmentsList(treatments);
    //     }
    // }, [creatorsList, sueTreatmentsList])

    const checkForerrorsInForm = () => {
        return formErrors.sueType || formErrors.sueHandler || formErrors.openingDate || formErrors.activityStatus || formErrors.insuranceCompany || formErrors.policyNumber;
    }

    const onApproveCloseSue = () => {
        onSaveClick();
        setShowConfirmationPopup(false);
        props.config.closeTab(props.customerId);
    }


    return (
        <>
            {showErrorFieldsWarning &&
                <ErrorFieldsAlert
                    ClosePopup={() => setShowErrorFieldsWarning(false)}
                    messageContent={"יש למלא את כל השדות המסומנים בכוכבית האדומה על מנת לשמור את התביעה"}
                />
            }
            <div className='sue-item-update-section'>
                {showConfirmationPopUp &&
                    // <ClientPopup
                    //     messageContent={'האם ברצונך לשמור את השינויים שביצעת בתביעה?'}
                    //     messageTitle={'שמירת שינויים בתביעה'}
                    //     approveBtnTitle={'שמור'}
                    //     ShowHidePopup={()=>setShowConfirmationPopup(false)}
                    //     ClosePopup={()=>onCloseSueDetails()}
                    //     OnApprove={()=>onApproveCloseSue()}
                    //     // onPrevious={()=>setShowConfirmationPopup(false)}
                    // />

                    <SueAlertPopUp
                        onApprove={() => onApproveCloseSue()}
                        onClose={() => onCloseSueDetails()}
                        onCancel={() => setShowConfirmationPopup(false)}
                    />
                }
                {/* {selectedDocumentUrl && <LeadDocumentPopup
                    ClosePopup={onHideDocumentPopUp}
                    documentUrl={selectedDocumentUrl}
                />} */}

                {
                clientDocumentUrl!=null?
                    (
                    <ClientDocumentPopup
                        ClosePopup={onHideDocumentPopUp}
                        documentUrl={clientDocumentUrl}
                    />
                    ):""
            }
                <PersonalSueDetails
                    customer={customer}
                    sueData={sueData}
                    address={address}
                    gender={gender}
                    customerPhone={customerPhone}
                    customerEmail={customerEmail}
                />



                {policyTypeId != 1 &&
                    <div className="clients-tabs-client-card-tabs client-details-view">
                        <div className={`client-card-tab pointer ${tab == 'General' ? 'selected' : ''}`} onClick={() => selectTab('General')}>
                            <div className="label">
                                כללי
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'CaseDetails' ? 'selected' : ''}`} onClick={() => selectTab('CaseDetails')}>
                            <div className="label">
                                פרטי המקרה {showLessTabs ? <></> : <>ונזקים</>}

                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'VictimsAndWitnesses' ? 'selected' : ''} ${showLessTabs ? 'hide' : ''}`} onClick={() => selectTab('VictimsAndWitnesses')}>
                            <div className="label">
                                נפגעים ועדים
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'AppraiserDetails' ? 'selected' : ''} ${showLessTabs ? 'hide' : ''}`} onClick={() => selectTab('AppraiserDetails')}>
                            <div className="label">
                                פרטי שמאי
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'OngoingCare' ? 'selected' : ''}`} onClick={() => selectTab('OngoingCare')}>
                            <div className="label" style={sueData.id == null || sueData.id == '' || sueData.id == undefined ? { color: 'gray' } : {}}>
                                טיפול שוטף
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'Documents' ? 'selected' : ''}`} onClick={() => selectTab('Documents')}>
                            <div className="label">
                                מסמכים
                            </div>
                            <div className="under-line"></div>
                        </div>
                    </div>
                }
                {
                    policyTypeId == 1 &&
                    <div className="clients-tabs-client-card-tabs client-details-view">
                        <div className={`client-card-tab pointer ${tab == 'General' ? 'selected' : ''}`} onClick={() => selectTab('General')}>
                            <div className="label">
                                כללי
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'VehicleDetails' ? 'selected' : ''}`} onClick={() => selectTab('VehicleDetails')}>
                            <div className="label">
                                פרטי נהג ורכב
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'AccidentDetails' ? 'selected' : ''}`} onClick={() => selectTab('AccidentDetails')}>
                            <div className="label">
                                פרטי תאונה ומקום
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'VictimsAndWitnesses' ? 'selected' : ''} ${sueData.rider ? 'hide' : ''}`} onClick={() => selectTab('VictimsAndWitnesses')}>
                            <div className="label">
                                נפגעים ועדים
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'InvolvedVehicles' ? 'selected' : ''}`} onClick={() => selectTab('InvolvedVehicles')}>
                            <div className="label">
                                רכבים מעורבים
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'AppraiserAndGarageDetails' ? 'selected' : ''}  ${sueData.rider ? 'hide' : ''}`} onClick={() => selectTab('AppraiserAndGarageDetails')}>
                            <div className="label">
                                פרטי שמאי ומוסך
                            </div>
                            <div className="under-line"></div>
                        </div>
                        {/* Ongoing care */}
                        <div className={`client-card-tab pointer ${tab == 'OngoingCare' ? 'selected' : ''}`} onClick={() => selectTab('OngoingCare')}>
                            <div className="label" style={sueData.id == null || sueData.id == '' || sueData.id == undefined ? { color: 'gray' } : {}}>
                                טיפול שוטף
                            </div>
                            <div className="under-line"></div>
                        </div>
                        <div className={`client-card-tab pointer ${tab == 'Documents' ? 'selected' : ''}`} onClick={() => selectTab('Documents')}>
                            <div className="label">
                                מסמכים
                            </div>
                            <div className="under-line"></div>
                        </div>
                    </div>
                }

                <div className={`sue-tab-content  ${policyTypeId != 1 && tab == 'General' ? '' : 'hide'}`}>
                    <GeneralOtherDetails
                        sueData={sueData}
                        sueInternalNumber={sueInternalNumber}
                        openingDate={openingDate}
                        closingDate={closingDate}
                        paymentDate={paymentDate}
                        customerCheckMaturityDate={customerCheckMaturityDate}
                        sueTypeLabel={sueTypeLabel}
                        sueActivityStatusLabel={sueActivityStatusLabel}
                        sueStatusLabel={sueStatusLabel}
                        sueHandlerName={sueHandlerName}
                        insuranceCompanyLabel={insuranceCompanyLabel}
                        formErrors={formErrors}
                        onParameterChange={onParameterChange}
                        onParameterPaymentChange={onParameterPaymentChange}
                        onDateChange={onDateChange}
                        onSueTypeChange={onSueTypeChange}
                        onSueActivityStatusChange={onSueActivityStatusChange}
                        onSueStatusChange={onSueStatusChange}
                        onSueHandlerChange={onSueHandlerChange}
                        onClearSueType={onClearSueType}
                        onClearSueActivityStatus={onClearSueActivityStatus}
                        onClearSueStatus={onClearSueStatus}
                        onClearSueHandler={onClearSueHandler}
                        onInternalNumberChange={onInternalNumberChange}
                        onInsuranceCompanyChange={onInsuranceCompanyChange}
                        onSueNewCommentChange={onSueNewCommentChange}
                        onSueAddComment={onSueAddComment}
                        sueCommentsList={sueCommentsList}
                        sueTypes={sueTypes}
                        newSueComment={newSueComment}
                        config={props.config}

                    />

                </div>
                <div className={`sue-tab-content  ${policyTypeId != 1 && tab == 'CaseDetails' ? '' : 'hide'}`}>
                    <AccidentDetailsAndPlace
                        sueData={sueData}
                        accidentTime={accidentTime}
                        onTimeChange={onTimeChange}
                        onBlurTime={onBlurTime}
                        onDateChange={onDateChange}
                        onAccidentDamageParameterChange={onAccidentDamageParameterChange}
                        onAccidentDamageSelectChange={onAccidentDamageSelectChange}
                        showLessTabs={showLessTabs}
                    />

                </div>
                <div className={`sue-tab-content  ${policyTypeId != 1 && tab == 'VictimsAndWitnesses' ? '' : 'hide'}`}>
                    <VictimsAndWitnesses
                        sueData={sueData}
                        onParticipantWitnessChange={onParticipantWitnessChange}
                    />

                </div>

                <div className={`sue-tab-content  ${policyTypeId != 1 && tab == 'AppraiserDetails' ? '' : 'hide'}`}>
                    <AppraiserDetails
                        garageDetails={garageDetails}
                        onGarageParamChange={onGarageParamChange}
                    />

                </div>
                <div className={`sue-tab-content ${tab == 'OngoingCare' ? '' : 'hide'}`}>
                    <TreatmentsSue
                        sueData={sueData}
                        sueTreatmentsList={sueTreatmentsList}
                        config={props.config}
                        showAddTreatmentPopup={props.config.showAddTreatmentPopup ? props.config.showAddTreatmentPopup : () => { }}
                        customerId={props.customerId ? props.customerId : ''}
                    />

                </div>
                <div className={`sue-tab-content  ${policyTypeId == 1 && tab == 'General' ? '' : 'hide'}`}>
                    <GeneralCarDetails
                        sueData={sueData}
                        sueInternalNumber={sueInternalNumber}
                        openingDate={openingDate}
                        closingDate={closingDate}
                        paymentDate={paymentDate}
                        customerCheckMaturityDate={customerCheckMaturityDate}
                        sueTypeLabel={sueTypeLabel}
                        sueActivityStatusLabel={sueActivityStatusLabel}
                        sueStatusLabel={sueStatusLabel}
                        sueHandlerName={sueHandlerName}
                        insuranceCompanyLabel={insuranceCompanyLabel}
                        formErrors={formErrors}
                        showNewPayment={showNewPayment}
                        newSuePayment={newSuePayment}
                        sueHandlingProcess={sueHandlingProcess}
                        onParameterChange={onParameterChange}
                        onParameterPaymentChange={onParameterPaymentChange}
                        onSueSummaryAmountChange={onSueSummaryAmountChange}
                        onChangeOpeningDate={onChangeOpeningDate}
                        onChangeClosingDate={onChangeClosingDate}
                        onChangePaymentDate={onChangePaymentDate}
                        onChangeCustomerCheckMaturityDate={onChangeCustomerCheckMaturityDate}

                        onDateChange={onDateChange}
                        onSueTypeChange={onSueTypeChange}
                        onSueActivityStatusChange={onSueActivityStatusChange}
                        onSueStatusChange={onSueStatusChange}
                        onSueHandlerChange={onSueHandlerChange}
                        onClearSueType={onClearSueType}
                        onClearSueActivityStatus={onClearSueActivityStatus}
                        onClearSueStatus={onClearSueStatus}
                        onClearSueHandler={onClearSueHandler}
                        onInternalNumberChange={onInternalNumberChange}
                        onInsuranceCompanyChange={onInsuranceCompanyChange}
                        onSueNewCommentChange={onSueNewCommentChange}
                        onSueAddComment={onSueAddComment}
                        onPolicyNumberChange={onPolicyNumberChange}
                        onHandlingTypeChange={onHandlingTypeChange}
                        onHandlingTypeCareChange={onHandlingTypeCareChange}
                        setShowNewPayment={setShowNewPayment}
                        onSueNewPaymentChange={onSueNewPaymentChange}
                        onSueNewPaymentDateChange={onSueNewPaymentDateChange}
                        onSueAddPayment={onSueAddPayment}
                        sueCommentsList={sueCommentsList}
                        sueTypes={sueTypes}
                        newSueComment={newSueComment}
                        config={props.config}
                        suePaymentsList={suePaymentsList}

                    />


                </div>
                <div className={`sue-tab-content  ${policyTypeId == 1 && tab == 'VehicleDetails' ? '' : 'hide'}`}>
                    <VehicleAndDriverDetails
                        driver={driver}
                        vehicleData={vehicleData}
                        onDriverParameterChange={onDriverParameterChange}
                        onVehicleParameterChange={onVehicleParameterChange}
                        onIsDriverVehicleOwnerChange={onIsDriverVehicleOwnerChange}
                        onDateChange={onDateChange}
                        onIsIsraeliLicenseChange={onIsIsraeliLicenseChange}
                        onChangeGearType={onChangeGearType}
                        licenseTypes={props.config.licenseTypes}
                        onChangeLicenseType={onChangeLicenseType}
                    />

                </div>
                <div className={`sue-tab-content  ${policyTypeId == 1 && tab == 'AccidentDetails' ? '' : 'hide'}`}>
                    <AccidentDetailsAndPlaceOnCar
                        sueData={sueData}
                        accidentTime={accidentTime}
                        onDateChange={onDateChange}
                        onBlurTime={onBlurTime}
                        onTimeChange={onTimeChange}
                        onAccidentDamageParameterChange={onAccidentDamageParameterChange}
                        onAccidentDamageSelectChange={onAccidentDamageSelectChange}
                    />

                </div>

                <div className={`sue-tab-content  ${policyTypeId == 1 && tab == 'VictimsAndWitnesses' ? '' : 'hide'}`}>
                    <VictimsAndWitnesses
                        sueData={sueData}
                        onParticipantWitnessChange={onParticipantWitnessChange}
                    />

                </div>
                <div className={`sue-tab-content  ${policyTypeId == 1 && tab == 'InvolvedVehicles' ? '' : 'hide'}`}>
                    <div className='white-block white-block-fixed-height'>
                        <section className=''>
                            <div className='section-sue-title'>
                                פרטי צד ג'
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            האם הנתבעת היא החברה של צד ג'
                                        </div>
                                        <div className="value">
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder=""
                                                value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].isThirdPartyDefendantCompany ? '1' : '0'}
                                                onChange={(value: string, option: any) => onIsDefendantCompanyChange(value, option, 0)}
                                                options={[
                                                    {
                                                        label: 'כן',
                                                        value: '1'
                                                    },
                                                    {
                                                        label: 'לא',
                                                        value: '0'
                                                    }]
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שם הסוכן
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyAgentName ? sueData.involvedVehiclesList[0].thirdPartyAgentName : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyAgentName', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            טל. הסוכן
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyAgentPhone ? sueData.involvedVehiclesList[0].thirdPartyAgentPhone : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyAgentPhone', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' תביעה צד ג'
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartySueNumber ? sueData.involvedVehiclesList[0].thirdPartySueNumber : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartySueNumber', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item"></div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס רישוי
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyLicensePlateNumber ? sueData.involvedVehiclesList[0].thirdPartyLicensePlateNumber : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyLicensePlateNumber', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שנה 
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartYear ? sueData.involvedVehiclesList[0].thirdPartYear : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartYear', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שם הדגם
                                        </div>
                                        <div className="value">
                                            <input
                                                type="text"
                                                value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyCarModel ? sueData.involvedVehiclesList[0].thirdPartyCarModel : ''}
                                                onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyCarModel', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            סוג הרכב
                                        </div>
                                        <div className="value">
                                            <Select
                                                style={{ width: '100%' }}
                                                placeholder=""
                                                value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 ?
                                                    getThirdPartyVehicleTypeValue(sueData.involvedVehiclesList[0].thirdPartyTypeOfVehicle) : ''}
                                                onChange={(value: string) => onInvolvedVehicleTypeChange(value, 'thirdPartyTypeOfVehicle', 0)}
                                                options={typeOfCars}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            חברת ביטוח צד ג'
                                        </div>
                                        <div className="value">
                                            <input type='text'
                                                list="companies_list"
                                                placeholder='בחר חברת ביטוח'
                                                onChange={(e) => onInvolvedVehicleInsuranceCompanyChange(e, 0)}
                                                value={involvedVehicleInsuranceCompanyLabel}
                                            />
                                            <datalist id="companies_list">
                                                {props.config.insuranceCompanies.map((c: any, i: number) => <option key={i} value={c.label}>{c.label}</option>)}
                                            </datalist>
                                            <div className={`icon x-clear pointer ${involvedVehicleInsuranceCompanyLabel == '' ? 'hide' : ''}`} onClick={() => onClearInvolvedVehicleInsuranceCompany(0)}></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' פוליסה
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyPolicyName ? sueData.involvedVehiclesList[0].thirdPartyPolicyName : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyPolicyName', 0, true)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שם בעל הרכב
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyCarOwnerName ? sueData.involvedVehiclesList[0].thirdPartyCarOwnerName : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyCarOwnerName', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' ת.ז. של בעל רכב
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyOwnerIdentifier ? sueData.involvedVehiclesList[0].thirdPartyOwnerIdentifier : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyOwnerIdentifier', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            טלפון
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyCarOwnerPhone ? sueData.involvedVehiclesList[0].thirdPartyCarOwnerPhone : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyCarOwnerPhone', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            נייד
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyCarOwnerMobile ? sueData.involvedVehiclesList[0].thirdPartyCarOwnerMobile : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyCarOwnerMobile', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            כתובת
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].thirdPartyOwnerAddress ? sueData.involvedVehiclesList[0].thirdPartyOwnerAddress : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'thirdPartyOwnerAddress', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <input type="checkbox" checked={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].isDriverOwnerOfTheVehicle} onChange={(e: any) => onInvolvedVechicleCheck(e)} className="checkbox-input" name="is-car-owner" value="1" />
                                    הנהג הוא בעל רכב
                                </div>
                                <div className="parameter-item"></div>
                                <div className="parameter-item"></div>
                                <div className="parameter-item"></div>
                                <div className="parameter-item"></div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שם נהג
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].driverName ? sueData.involvedVehiclesList[0].driverName : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'driverName', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            כתובת
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].driverAddress ? sueData.involvedVehiclesList[0].driverAddress : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'driverAddress', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' ת.ז.
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].driverIdentifier ? sueData.involvedVehiclesList[0].driverIdentifier : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'driverIdentifier', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' רשיון
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].licenseNumber ? sueData.involvedVehiclesList[0].licenseNumber : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'licenseNumber', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            טלפון
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].driverPhone1 ? sueData.involvedVehiclesList[0].driverPhone1 : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'driverPhone1', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            נייד
                                        </div>
                                        <div className="value">
                                            <input type="text" value={sueData.involvedVehiclesList && sueData.involvedVehiclesList.length > 0 && sueData.involvedVehiclesList[0].driverPhone2 ? sueData.involvedVehiclesList[0].driverPhone2 : ''} onChange={(e: any) => onInvolvedVehicleChange(e, 'driverPhone2', 0)} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className='with-top-border'>
                            <div className='parameter-item'>
                                <button className="button blue flex-centered flex-justify-center" onClick={() => onAddInvolvedVehicle()}>הוסף רכב</button>
                            </div>
                            <div className='section-sue-title'>
                                פרטי רכבים מעורבים אחרים
                            </div>


                            {
                                sueData.involvedVehiclesList && sueData.involvedVehiclesList.map((iv: any, index: number) => {
                                    if (index > 0) {
                                        return (

                                            <InvolvedVehicle
                                                vehicle={iv}
                                                index={index}
                                                insuranceCompanies={props.config.insuranceCompanies}
                                                onInvolvedVehicleChange={onInvolvedVehicleChange}
                                                onIsDefendantCompanyChange={onIsDefendantCompanyChange}
                                                onTypeOfVehicleChange={onTypeOfVehicleChange}
                                                onInvolvedVehicleInsuranceCompanyChange={onInvolvedVehicleInsuranceCompanyChange}
                                                onClearInvolvedVehicleInsuranceCompany={onClearInvolvedVehicleInsuranceCompany}
                                                onInvolvedVechicleCheck={onInvolvedVechicleCheck}
                                                typeOfCars={typeOfCars}
                                            />

                                        )
                                    }

                                })
                            }
                        </section>
                    </div>
                </div>
                <div className={`sue-tab-content  ${policyTypeId == 1 && tab == 'AppraiserAndGarageDetails' ? '' : 'hide'}`}>
                    <div className='white-block white-block-fixed-height'>
                        <section className=''>
                            <div className='section-sue-title'>
                                פרטי שמאי
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שם השמאי
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.assessorName} onChange={(e: any) => onGarageParamChange(e, 'assessorName')} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>

                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' טלפון
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.assessorPhoneNumber} onChange={(e: any) => onGarageParamChange(e, 'assessorPhoneNumber')} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            טלפון נייד
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.assessorMobilePhoneNumber} onChange={(e: any) => onGarageParamChange(e, 'assessorMobilePhoneNumber')} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            פקס
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.assessorFaxNumber} onChange={(e: any) => onGarageParamChange(e, 'assessorFaxNumber')} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            דוא"ל
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.assessorEmail} onChange={(e: any) => onGarageParamChange(e, 'assessorEmail')} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-row single-item">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            כתובת
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.assessorAddress} onChange={(e: any) => onGarageParamChange(e, 'assessorAddress')} onBlur={(e: any) => { }} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <section className=''>
                            <div className='section-sue-title'>
                                פרטי מוסך
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            שם מוסך
                                        </div>
                                        <div className="value">

                                            <input type='text'
                                                list="sue_garages_list"
                                                placeholder='בחר שם מוסך'
                                                onChange={onGarageChange}
                                                value={
                                                    sueGarageLabel
                                                }
                                            />
                                            <datalist id="sue_garages_list">
                                                {props.config.garages && props.config.garages.map((c: any, i: number) => <option key={i} value={`${c.shem_mosah}`}>{c.shem_mosah}</option>)}
                                            </datalist>
                                            <div className={`icon x-clear pointer ${sueGarageLabel == '' ? 'hide' : ''}`} onClick={() => { onClearGarage() }}></div>
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            איש קשר
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.garageContactPerson} onChange={(e: any) => onGarageParamChange(e, 'garageContactPerson')} onBlur={(e: any) => { }} disabled={garageChoosen} />
                                        </div>
                                    </div>
                                </div>

                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מוסך הסדר
                                        </div>
                                        <div className="value">
                                            <Select
                                                value={garageDetails && garageDetails.garageDetails ? '1' : '2'}
                                                style={{ width: '100%' }}
                                                options={[
                                                    {
                                                        label: 'כן',
                                                        value: '1'
                                                    },
                                                    {
                                                        label: 'לא',
                                                        value: '2'
                                                    }]}
                                                onChange={onGarageTidyUpChange}
                                                disabled={garageChoosen}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מספר זיהוי
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.garageIdentity} onChange={(e: any) => onGarageParamChange(e, 'garageIdentity', true)} onBlur={(e: any) => { }} disabled={garageChoosen} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' נייד
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.garageMobile} onChange={(e: any) => onGarageParamChange(e, 'garageMobile', true)} onBlur={(e: any) => { }} disabled={garageChoosen} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' טלפון
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.garagePhone} onChange={(e: any) => onGarageParamChange(e, 'garagePhone', true)} onBlur={(e: any) => { }} disabled={garageChoosen} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            מס' פקס
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.garageFaxNumber} onChange={(e: any) => onGarageParamChange(e, 'garageFaxNumber', true)} onBlur={(e: any) => { }} disabled={garageChoosen} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="parameter-row">
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            דוא"ל
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.garageEmail} onChange={(e: any) => onGarageParamChange(e, 'garageEmail')} onBlur={(e: any) => { }} disabled={garageChoosen} />
                                        </div>
                                    </div>
                                </div>
                                <div className="parameter-item">
                                    <div className="field">
                                        <div className="title">
                                            כתובת
                                        </div>
                                        <div className="value">
                                            <input type="text" value={garageDetails && garageDetails.garageAddress} onChange={(e: any) => onGarageParamChange(e, 'garageAddress')} onBlur={(e: any) => { }} disabled={garageChoosen} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>

                <div className={`sue-tab-content ${tab == 'Documents' ? '' : 'hide'}`}>
                    {sueData.customerId && sueData.id &&
                        <SueDocuments
                            customerId={sueData.customerId}
                            relationId={sueData.id}
                            retationType={4}
                            displayFile={(fileUrl: string) => { }}
                            showAddTreatmentPopup={props.config.showAddTreatmentPopup ? props.config.showAddTreatmentPopup : () => { }}
                        />
                    }
                    {/* <div className='white-block white-block-fixed-height'>
                    <section className=''>
                        <div className='section-sue-title'>
                        מסמכים
                        </div>
                    </section>
                    <section>
                        <div className="content-table">
                            <div className="sue-documents-section">
                                <div className="sue-documents-item" style={{fontWeight: 'bold', color: 'gray'}}>
                                שם קובץ
                                </div>
                                <div className="sue-documents-item" style={{fontWeight: 'bold', color: 'gray'}}>
                                תאריך הוספה
                                </div>
                                <div className="sue-documents-item" style={{fontWeight: 'bold', color: 'gray'}}>
                                נוצר ע"י
                                </div>
                                <div className="sue-documents-item" style={{fontWeight: 'bold', color: 'gray'}}>
                                גודל
                                </div>
                                <div className="sue-documents-item" style={{fontWeight: 'bold', color: 'gray'}}>
                                הערות
                                </div>
                                <div className="sue-documents-item" style={{fontWeight: 'bold', color: 'gray'}}>
                                    
                                   
                                    <button type="button" className="button blue has-icon flex-centered flex-justify-center" onClick={handleButtonClick}>
                                        <div className="icon add"></div>
                                    </button>
                                </div>
                            </div>
                            
                                
                            {sueDocumentList && sueDocumentList.sort((a, b) => (a.createdDate > b.createdDate ? -1 : 1))
                            .map((document: any, index: number)=>{
                                const filePathData = document.path.split("/");
                                const fileName = filePathData[filePathData.length - 1];
                                const user = props.config && props.config.users && props.config.users.find((u: any) => u.id === document.createdById);
                                document.userName = user ? user.fullName : '';
                                return (
                                    <>
                                    <SueDocumentFile
                                        document={document}
                                        index={index}
                                        key={index}
                                        onSelectDocument={(document: any)=>{}}
                                        onFileDownload={(id: string, index?: number) => onFileDownload(id)}
                                        onFileDelete={(id: string, index?: number) => onFileDelete(id)}
                                        onFileSelect={(id: string, index?: number) => onFileSelect(id)} />
                                    </>
                                )
                            })}
                            {showFileUpload && <div className="file-upload-row">
                                        <input
                                        className='file-upload-input'
                                            type="file"
                                            // ref={fileInputRef}
                                            onChange={handleFileChange}
                                        />
                                        <input className='input-comment-file' type='text' value={uploadFileComment} onChange={onFileCommentChange} />
                                    
                                        <button onClick={onAddFileClick} className='file-upload-btn'>
                                            <div className="label">
                                                הוסף קובץ
                                            </div>
                                        </button>
                                    
                                </div>}
                        </div>
                    </section>
                </div> */}
                </div>


                <div className="client-tab-action-row">
                    <button onClick={onSaveClick} style={{ marginLeft: 10 }}>
                        <div className="icon icon-save"></div>
                        <div className="label">
                            שמירה
                        </div>
                    </button>
                    <button id="btn-cancel-edit" onClick={onCloseClick} style={{ marginLeft: 10 }}>
                        <div className="icon icon-x"></div>
                        <div className="label">
                            סגור
                        </div>
                    </button>

                    <button id="btn-cancel-edit" onClick={(e: any) => PrintSue(e)}>
                        <div className="icon print pointer"></div>
                        <div className="label">
                            הדפסה
                        </div>
                    </button>

                </div>
            </div>
        </>

    );
}
export default SueItemUpdate;